import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { Roi } from '../../model/roi';
import { RoiService } from '../../service/roi.service';
import 'parse';
const parse: typeof Parse = require('parse');
import { TchekOldService } from '../../service/tchek-old.service';
import { fabric } from 'fabric_gesture';
import { Tchek } from '../../model/tchek';
import { environment } from '../../../environments/environment';
import { NotificationsService } from 'angular2-notifications';
import { ParseFunctionService } from '../../service/parsefunction.service';
import { AwsService } from '../../service/aws.service';
import { HttpClient } from '@angular/common/http';
import { DetectionData } from '../../model/detection-data';
import { AnnotationService } from '../../service/annotation.service';
import { iPolygon } from '../../model/geometry';
import { VehicleDamagePipe } from '../../pipes/vehicle-damage.pipe';
import { Damage } from '../../model/damage.model';
import { FolderService } from '../../service/folder.service';
import { DamageService } from '../../service/damage.service';
import { Subscription, operators } from 'rxjs';
import { ParametersService } from '../../service/parameters.service';
import { Style } from '../../model/settings.model';
import { SearchService } from '../../service/search.service';
import { ClassificationService } from '../../service/classification.service';
import * as jquery from 'jquery'
import { Router } from '@angular/router';
import { Tchekb, TchekImages, TchekType } from '../../model/tchekb.model';
import { TchekImage } from '../../model/image';
import { uid } from 'uid';
import { ToastService } from '../../service/toast.service';
import { VehicleLocationPipe } from '../../pipes/vehicle-location.pipe';
import { ImagesService } from '../../service/images.service';
import { I18n } from '@ngx-translate/i18n-polyfill';

// Extending fabric Polygon class to make a new one with uid attribute
fabric.iPolygon = iPolygon;

declare const $: any;

export enum CanvasState {
  Initializing,
  Idle,
  LoadingPicture
}

class ListAnimation {
  array: Array<Animation>;

  constructor(animations?: Array<Animation>) {
    this.array = animations ? animations : [];
  }

  get(animationName: number | string): Animation | undefined {
    const index = this.array.findIndex(a => (a.folder === animationName));
    // console.log('searching for ', animationName, ' found ', index, ' listAnimations ', this.array);
    return (index > -1) ? this.array[index] : undefined;
  }

  setCurrentPicture(animationName: number | string, url: string): boolean {
    const index = this.array.findIndex(c => (c.folder === animationName));
    if (index > -1) {
      this.array[index].currentPicture = url;
      return true;
    } else
      return false;
  }
  setActualVideo(animationName: number | string, url: string): boolean {
    const index = this.array.findIndex(c => (c.folder === animationName));
    if (index > -1) {
      this.array[index].actualVideo = url;
      return true;
    } else
      return false;
  }
  setMiniPicture(animationName: number | string, url: string): boolean {
    const index = this.array.findIndex(c => (c.folder === animationName));
    if (index > -1) {
      this.array[index].miniPicture = url;
      return true;
    } else
      return false;
  }

  sort() {
    this.array = this.array.sort(function (a, b) {
      if (a && b)
        return parseInt(a.folder, 10) - parseInt(b.folder, 10);
    });
  }

  empty() {
    if (!this.array)
      return true;
    else if (this.array.length < 1)
      return true;
    else
      return false;
  }
}

class Animation {

  numberPicture: string;
  totalPictures: number;
  folder: string;
  folderId: string;
  path: string;
  descCam: string;
  name: string;
  date: Date;
  currentPicture: string;
  actualVideo: string;
  miniPicture: string;


  constructor(animation: Animation) {
    this.numberPicture = animation.numberPicture;
    this.totalPictures = animation.totalPictures;
    this.folder = animation.folder;
    this.folderId = animation.folderId;
    this.path = animation.path;
    this.descCam = animation.descCam;
    this.name = animation.name;
    this.date = animation.date;
    this.currentPicture = animation.currentPicture;
    this.actualVideo = animation.actualVideo;
    this.miniPicture = animation.miniPicture;
  }
}

class RoiMatrix {

  array: Parse.Object[]; // Will contain an array of ParseObjects

  constructor() { }

  pictureHasRois(folder: string, pictureNumber: number): boolean {
    if (!this.array) {
      console.error('Calling pictureHasRois() while array is undefined');
      return false;
    }

    for (let i = 0; i < this.array.length; i++) {
      if (
        this.array[i].get('folder') === folder &&
        this.array[i].get('picture') === pictureNumber
      )
        return true;
    }

    return false;
  }

  getPictureRoisFromImage(image: TchekImage) {
    if (!this.array) {
      console.error('Calling pictureHasRois() while array is undefined');
      return undefined;
    }
    return this.array
      .filter(r => { return r.get('imagePtr') ? r.get('imagePtr').id === image.id : false });
  }

  getPictureRois(folder: string, pictureNumber: number | string): Array<Parse.Object> {
    if (!this.array) {
      console.error('Calling pictureHasRois() while array is undefined');
      return undefined;
    }
    if (typeof pictureNumber === 'string')
      pictureNumber = parseInt(pictureNumber, 10);

    return this.array
      .filter(r => r.get('folder') === folder && r.get('picture') === pictureNumber);
  }

  findById(parseId): any {
    if (!this.array) {
      console.error('Calling findById() while array is undefined');
      return undefined;
    }

    for (let i = 0; i < this.array.length; i++)
      if (this.array[i].id === parseId) return this.array[i];

    return false;
  }

  getIndexById(parseId): any {
    if (!this.array) {
      console.error('Calling getIndexById() while array is undefined');
      return undefined;
    }

    for (let i = 0; i < this.array.length; i++)
      if (this.array[i].id === parseId) return i;

    return false;
  }

  updateMovedRoi(parseId, newX, newY): void {
    if (!this.array) {
      console.error('Calling updateMovedRoi() while array is undefined');
      return undefined;
    }

    for (let i = 0; i < this.array.length; i++) {
      if (this.array[i].id === parseId) {
        this.array[i].set('centerX', newX);
        this.array[i].set('centerY', newY);
        return;
      }
    }
  }

  updateRoi(newRoiVersion: Parse.Object) {
    return this.array[this.getIndexById(newRoiVersion.id)] = newRoiVersion;
  }

  removeFromFGroup(fabricGroup: any, inspectedByAlto: boolean): Array<Parse.Object> {
    //SBE
    let type = inspectedByAlto ? 'rect' : 'circle'
    const parseId = fabricGroup.getObjects(type)[0].group.parseId;
    this.array = this.array.filter(({ id }) => (id !== parseId));
    return this.array;
  }

  remove(roiId: any): Array<Parse.Object> {
    this.array = this.array.filter(({ id }) => (id !== roiId));
    return this.array;
  }
}


@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.less']
})
export class CanvasComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  // Consts
  public static _zoomResetShortcut = 'r';
  public static _partsModeShortcut = 'm';
  public static _imageExtension = '.jpg';
  public static _tweakDebounceTimeMs = 70;
  // Vars
  private video: any;
  @Input() tchekId: string;
  @Input() cameraNumber: number;
  @Input() pictureNumber: number;
  @Input() videoNumber: number;
  @Input() fgamma: number;
  @Input() fcontrast: number;
  @Input() insideClassificationImage: boolean;
  @Input() fsaturation: number;
  @Input() finversion: boolean;
  @Input() fmirror: boolean;
  @Input() editMode: boolean; // ? Merge modes in an enumeration
  @Input() annotateMode: boolean;
  annotateModeSave: boolean = false
  @Output() annotateModeChange: EventEmitter<boolean>;
  @Input() compareMode: boolean;
  @Input() canvasId: number;
  @Input() minProbVehicle: number;
  @Output() state: EventEmitter<CanvasState>;
  @Output() editingRoi: EventEmitter<number>;

  // For open images into canvas
  @Input() currentMode: string;
  currentImage: TchekImage;
  @Input() tchek: TchekImages;
  @Input() damageOnImage: boolean;

  private fcanvas: fabric.CanvasEx;
  private rois: RoiMatrix;
  private fimage: fabric.Image;
  private fvideo: fabric.Image;
  private listAnimation: ListAnimation;
  private isMobile: boolean;
  private canvasFullWidth: number;
  private canvasFullHeight: number;
  private circle: fabric.Circle;
  date: Date;
  private deviceId: string;
  private ipMachine: string;
  private vehicleId: string;
  private stateValue: CanvasState;
  private isDrawing: boolean;
  private origX: number;
  private detectionData: DetectionData;
  private partsMode: boolean;
  typeDamage = '';
  private annotationLoaded = false;
  autoRoiMasksEnabled = false;
  private timers: { [filter: string]: NodeJS.Timer };
  subscription: Subscription[] = [];
  style: Style;
  hideDamages: boolean = false;
  isSuperAdmin: boolean = false;
  activeRoiAdminDrawer = false;
  tchekcompany: string;
  canDetection = false;
  renderUid: string
  videoResolution: { width: number, height: number } = undefined

  constructor(
    private readonly i18n: I18n,
    private _toastService: ToastService,
    private _roiService: RoiService,
    private _router: Router,
    private _tchekService: TchekOldService,
    private _notificationService: NotificationsService,
    private _parseFunction: ParseFunctionService,
    private _awsService: AwsService,
    private _http: HttpClient,
    private _annotationService: AnnotationService,
    private readonly _classificationService: ClassificationService,
    private readonly _damageService: DamageService,
    private _vehicleDamagePipe: VehicleDamagePipe,
    private readonly _folderService: FolderService,
    private readonly _imagesService: ImagesService,
    private readonly _parametersService: ParametersService,
    private readonly _searchService: SearchService,
    private readonly _damageLocationPipe: VehicleLocationPipe
  ) {
    this.canDetection = this._parametersService.canDetection;
    this.activeRoiAdminDrawer = parse.User.current().get('companyPtr').get('settingsPtr').get("activeRoiAdminDrawer") ? parse.User.current().get('companyPtr').get('settingsPtr').get("activeRoiAdminDrawer") : false;
    this.isSuperAdmin = this._parametersService.isSuperAdmin
    this.listAnimation = new ListAnimation([]);
    this.fgamma = 1; this.fsaturation = 0; this.fcontrast = 0; this.finversion = false;
    this.isMobile = false; this.editMode = false;
    this.date = new Date();
    this.annotateModeChange = new EventEmitter<boolean>();
    this.state = new EventEmitter<CanvasState>();
    this.editingRoi = new EventEmitter<number>();
    this.stateValue = CanvasState.Initializing;
    this.state.emit(this.stateValue);
    this.rois = new RoiMatrix();
    this.timers = {};
    this.style = this._parametersService.getAll().style;
    if (!this.style)
      this.style = { damageColor: 'white', newDamageColor: 'red', dashboard: [], contrast: 0, gamma: 1, saturation: 0 };


    // Subclassing fabric.Canvas to add double click detection
    fabric.CanvasEx = fabric.util.createClass(
      fabric.Canvas,
      /** @lends fabric.Canvas */ {
        _bindEvents: function () {
          const self = this;

          self.callSuper('_bindEvents');

          self._onDoubleClick = self._onDoubleClick.bind(self);
        },
        _initEventListeners: function () {
          const self = this;
          self.callSuper('_initEventListeners');

          fabric.util.addListener(
            self.upperCanvasEl,
            'dblclick',
            self._onDoubleClick
          );
        },
        _onDoubleClick: function (e) {
          const self = this;

          const target = self.findTarget(e);
          self.fire('mouse:dblclick', {
            target: target,
            e: e
          });

          if (target && !self.isDrawingMode) {
            // To unify the behavior, the object's double click event does not fire on drawing mode.
            target.fire('object:dblclick', {
              e: e
            });
          }
        },
        removeListeners: function () {
          const self = this;
          self.callSuper('removeListeners');

          fabric.util.removeListener(
            self.upperCanvasEl,
            'dblclick',
            self._onDoubleClick
          );
        },
        /**
         * Clears all contexts but the background (main, top) of an instance
         * @return {fabric.CanvasEx} thisArg
         * @chainable
         */
        clearTop: function () {
          this._objects.length = 0;
          // this.backgroundImage = null;
          this.overlayImage = null;
          this.backgroundColor = '';
          this.overlayColor = '';
          if (this._hasITextHandlers) {
            this.off('mouse:up', this._mouseUpITextHandler);
            this._iTextInstances = null;
            this._hasITextHandlers = false;
          }
          this.clearContext(this.contextContainer);
          this.fire('canvas:cleared');
          this.renderOnAddRemove && this.requestRenderAll();
          return this;
        }
      }
    );


    this.subscription[0] = _annotationService.annotationHideObs.subscribe(hide => {
      if (this.hideDamages !== hide) {
        this.hideDamages = hide;
        this.addRoisToCanvas();
      }
    })

    this.subscription[1] = _damageService.createroiObs.subscribe(data => {
      this.circle = data.circle;
      this.vehicleId = data.vehicleId;
      this.listAnimation = data.listAnimation;
      this.pictureNumber = data.pictureNumber;
      this.cameraNumber = data.cameraNumber;
      this.fvideo = data.fvideo;
      this.tchekId = data.tchekId;
      this.rois = data.rois;
      this.fcanvas = data.fcanvas;

      this.renderUid = uid(10)
      if (this.currentMode === 'video')
        this.renderCanvas(data.listAnimation.get(data.cameraNumber).currentPicture, this.renderUid.valueOf());
      else if (this.currentImage && this.currentMode === 'image') {
        this.renderCanvas(this.currentImage.file.url(), this.renderUid.valueOf(), false, true)
      }
    })

    this.subscription[2] = _parametersService.editDamageFilterObs.subscribe(() => {
      console.log('editDamageFilterObs');

      this._damageService.reloadDamages = true
      this._damageService.getByTchek(this.tchekId).then(damages => {
        this._roiService.getTchekRois(this.tchekId).then(rois => {

          this.rois.array = rois
            .filter(r => {
              let verif = false;
              damages.forEach(d => {
                if (r.get("damagePtr") === undefined || r.get("damagePtr").id === undefined)
                  verif = false
                else if (d && d.id === r.get("damagePtr").id)
                  verif = true;
              })
              return verif
            });

          console.log(damages, rois, this.rois.array);
        })
      })
    })

    this.subscription[3] = _classificationService.hideDamagesObs.subscribe((hide) => {
      if (this.hideDamages !== hide) {
        this.hideDamages = hide;
        this.addRoisToCanvas();
      }
    })

    this.subscription[4] = _classificationService.createAnnotationObs.subscribe((damage) => {
      //refresh annotation here
    })


    this.subscription[5] = _roiService.selectNewRoiObs.subscribe((hide) => {
      this.addRoisToCanvas();
    })


    this.subscription[6] = _awsService.changeTunnelObs.subscribe(() => {
      if (this.currentMode === 'video') {
        this._awsService.generateUrlPromise(this.deviceId + '/' +
          this.tchek.path +
          '/' +
          environment.detectionFilename, this.ipMachine).then(signedUrl => {
            // console.log('detection signed URL ', signedUrl);
            // Requesting the JSON file
            this._http.get(signedUrl).subscribe((data: any) => {
              if (data === undefined)
                data = []
              this.detectionData = new DetectionData(signedUrl, data, this.getSize());
            });
          }, error => console.error('Could not sign detection file URL', error));
      }
    })

    this.subscription[7] = _imagesService.reloadImagesObs.subscribe((image) => {
      this.currentImage = image
      console.log('render ', this.currentImage.id);

      if (this.fcanvas && this.currentImage && this.currentMode === 'image') {
        this.renderUid = uid(10)
        this.renderCanvas(this.currentImage.file.url(), this.renderUid.valueOf(), true, true)
      }
    })


    this.subscription[8] = _damageService.selectRoiObs.subscribe((data) => {
      console.log('changed pic number selectRoiObs', data.image);
      this.setCurrentPictureNUM(data.image).then((pictureUrl) => {
        this.renderUid = uid(10)
        this.renderCanvas(pictureUrl, this.renderUid.valueOf(), false, false, data.image);
      }, error => console.error('Cannot setCurrentPicture() 1', error));
    })
  }

  ngOnInit() {
    if (isNaN(this.canvasFullHeight)) {
      this.canvasFullHeight = 400
      console.warn('canvasFullHeight is NaN set :', this.canvasFullHeight)
    }
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    )
      this.isMobile = true;
    else
      this.isMobile = false;

    // Storing tchek data for later use and initializing component
    if (this.tchekId && this.insideClassificationImage !== true) {
      this._tchekService.getTchek(this.tchekId).then(tchek => {

        if (tchek.get('isDeleted') || (environment.isLocal && tchek.get('isDeletedFromLocal'))) {
          this._toastService.toastOpen(undefined,
            this.i18n({
              id: 'deletedScan',
              value: "Ce scan est supprimé.",
              description: "Ce scan est supprimé.",
              meaning: "canvas"
            }), "error");
          if (this.isSuperAdmin !== true)
            this._router.navigate(['/'])
        }

        this.date = tchek.get('tchekCreatedAt');
		if (tchek.get('type') !== 4 || this.isSuperAdmin){
			this.ipMachine = tchek.get('devicePtr').get('ipMachine')
        this.tchekcompany = `- ${tchek.get('devicePtr').get('companyPtr').get('identifier').toUpperCase()} - ${tchek.get('devicePtr').get('serialNumber').toUpperCase()}`;
		
        this.deviceId = tchek.get('devicePtr').get('webObjectId')
          ? tchek.get('devicePtr').get('webObjectId')
          : tchek.get('devicePtr').id;

		  // Get detection of parts and damages from detection.json
		  if (tchek.get('detectionFinished') && environment.isLocal) {
			this._awsService.generateUrlPromise(this.deviceId + '/' +
			  tchek.get('path') +
			  '/' +
			  environment.detectionFilename, tchek.get('devicePtr').get('ipMachine')).then(signedUrl => {
				// console.log('detection signed URL ', signedUrl);
				// Requesting the JSON file
				this._http.get(signedUrl).subscribe((data: any) => {
				  if (data === undefined)
					data = []
				  this.detectionData = new DetectionData(signedUrl, data, this.getSize());
				});
			  }, error => console.error('Could not sign detection file URL', error));
		  }
}

        this.changeCanvasSize();
      });

    }

    // R to reset view and M to enable parts mode
    $(document).on('keypress', evt => {
      if (!this.fcanvas)
        return console.warn('Event "keypress" called with undefined fcanvas');

      if (evt.key.toLowerCase() === CanvasComponent._zoomResetShortcut) {
        // Resetting zoom and recentering the image
        this.fcanvas.setZoom(1);
        this.fcanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        this.fcanvas.requestRenderAll();
      } else if (evt.key.toLowerCase() === CanvasComponent._partsModeShortcut) {
        if (this.fcanvas && !this.editMode) {
          this.partsMode = !this.partsMode;
          if (this.partsMode)
            this.fcanvas.defaultCursor = 'help';
          else {
            this.fcanvas.defaultCursor = 'move';
            this.fcanvas.setCursor(this.fcanvas.defaultCursor);
            this.renderUid = uid(10)
            this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture, this.renderUid.valueOf(), true);
          }
        }
      }
    });
  }

  resetViewerCanvas(tapCpt: number) {
    //console.log("TapCpt", tapCpt);
    if (tapCpt != 3)
      return;
    this.fcanvas.setZoom(1);
    this.fcanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    this.fcanvas.requestRenderAll();
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('changes ', changes);
    // If not main canvas and not visible (because not in comparison mode)
    if (this.canvasId > 0 && !this.compareMode)
      return;

    //change tchek
    if (changes.tchek && changes.tchek.currentValue && this.insideClassificationImage !== true) {
      console.log('change tchekPtr')
      if (this.isSuperAdmin)
        this.tchekcompany = `- ${this.tchek.devicePtr.companyPtr.get('identifier').toUpperCase()}
     - ${this.tchek.devicePtr.serialNumber.toUpperCase()}`;

      this.date = this.insideClassificationImage ? undefined : this.tchek.tchekCreatedAt;
     if (this.tchek.type !== 4) 
	  this.deviceId = this.tchek.devicePtr.webObjectId
        ? this.tchek.devicePtr.webObjectId
        : this.tchek.devicePtr.id;

      // Get detection of parts and damages from detection.json
      if (this.tchek.detectionFinished && environment.isLocal) {
        this._awsService.generateUrlPromise(this.deviceId + '/' +
          this.tchek.path +
          '/' +
          environment.detectionFilename).then(signedUrl => {
            // console.log('detection signed URL ', signedUrl);
            // Requesting the JSON file
            this._http.get(signedUrl).subscribe((data: any) => {
              if (data === undefined)
                data = []
              this.detectionData = new DetectionData(signedUrl, data, this.getSize());
            });
          }, error => console.error('Could not sign detection file URL', error));
      }
    }


    // Tchek id changed
    if (changes.tchekId && changes.tchekId.currentValue) {
      if (this.insideClassificationImage && this.fcanvas) return
      // Storing tchek data for later use and initializing component
      this.tchekId = changes.tchekId.currentValue;
      console.log('tchekId changed', this.tchekId, this.canvasId);
      if (this.tchekId) {
        this._tchekService.getTchek(this.tchekId).then(tchek => {
          this.date = tchek.get('tchekCreatedAt');
		  if (tchek.get('type') !== 4 || this.isSuperAdmin){
          this.deviceId = tchek.get('devicePtr').get('webObjectId')
            ? tchek.get('devicePtr').get('webObjectId')
            : tchek.get('devicePtr').id;
           this.ipMachine = tchek.get('devicePtr').get('ipMachine')}
          // Initializing Tchek data and Fabric canvas
          this.tchekInitializer().then(() => {
            this.fabricInitializer();
          }, (err) => console.error('Failed initalizing Tchek data', err));
        });
      }
    }

    if (this.currentMode === 'video')
      if ((changes.cameraNumber && changes.cameraNumber.currentValue !== undefined && !changes.cameraNumber.firstChange)
        && (changes.pictureNumber && changes.pictureNumber.currentValue !== undefined && !changes.pictureNumber.firstChange)) {

        console.log('changes picture + cam ');

        this.video.nativeElement.removeEventListener('seeked', this.handleVideoSeeked);
        $('#video' + this.canvasId).attr('src', this.listAnimation.get(changes.cameraNumber.currentValue).actualVideo);
        this.video.nativeElement.addEventListener('canplaythrough', this.handleVideoReady, { once: true });

        this.video.nativeElement.addEventListener("loadedmetadata", (e) => {
          this.handleVideoLoaded(e)
          this.setCurrentPicture(changes.pictureNumber.currentValue).then((pictureUrl) => {
            this.renderUid = uid(10)
            this.renderCanvas(pictureUrl, this.renderUid.valueOf());
          }, error => console.error('Cannot setCurrentPicture() 2', error))
          this.seek(changes.pictureNumber.currentValue);
        }, { once: true });

        this.video.nativeElement.onerror = () => {
          this.video.nativeElement.crossOrigin = 'anonymous';
          this.setCurrentPicture(changes.pictureNumber.currentValue).then((pictureUrl) => {
            this.renderUid = uid(10)
            this.renderCanvas(pictureUrl, this.renderUid.valueOf());
          }, error => console.error('Cannot setCurrentPicture() 3', error))
        };

      } // Camera changed
      else {
        if (changes.cameraNumber && changes.cameraNumber.currentValue !== undefined && !changes.cameraNumber.firstChange) {
          console.log('camera changed state ', changes.cameraNumber.currentValue, this.listAnimation);
          if (this.fcanvas) this.fcanvas.clear()
          this.video.nativeElement.removeEventListener('seeked', this.handleVideoSeeked);
          // console.log('changing src video cvs ', this.canvasId, ' vid', this.listAnimation.get(changes.cameraNumber.currentValue).actualVideo);
          $('#video' + this.canvasId).attr('src', this.listAnimation.get(changes.cameraNumber.currentValue).actualVideo);
          this.video.nativeElement.addEventListener("loadedmetadata", (e) => {
            this.handleVideoLoaded(e)
            this.setCurrentPicture(this.pictureNumber).then((pictureUrl) => {
              this.renderUid = uid(10)
              this.renderCanvas(pictureUrl, this.renderUid.valueOf());
            }, error => console.error('Cannot setCurrentPicture() 4', error));
          }, { once: true });

          this.video.nativeElement.onerror = () => {
            this.video.nativeElement.crossOrigin = 'anonymous';
            this.setCurrentPicture(this.pictureNumber).then((pictureUrl) => {
              this.renderUid = uid(10)
              this.renderCanvas(pictureUrl, this.renderUid.valueOf());
            }, error => console.error('Cannot setCurrentPicture() 5', error));
          };

          this.video.nativeElement.addEventListener('canplaythrough', this.handleVideoReady, { once: true });
        } // Changed picture on slider release
        if (changes.pictureNumber && changes.pictureNumber.currentValue !== undefined && !changes.pictureNumber.firstChange) {
          console.log('changed pic number', changes.pictureNumber.currentValue);
          this.seek(changes.pictureNumber.currentValue);
          this.setCurrentPicture(changes.pictureNumber.currentValue).then((pictureUrl) => {
            this.renderUid = uid(10)
            this.renderCanvas(pictureUrl, this.renderUid.valueOf());
          }, error => console.error('Cannot setCurrentPicture() 6', error));
        }
      }


    // Changed picture while sliding
    if (changes.videoNumber && changes.videoNumber.currentValue !== undefined && !changes.videoNumber.firstChange) {
      if (this.fcanvas)
        this.fcanvas.clearTop();
      this.seek(changes.videoNumber.currentValue);
    }

    // Changed filters value
    /* If all filters change at the same time, it's either a reset or an
    initialization which means we need to apply filters immediately
    without debounce time */
    if (changes.fgamma &&
      changes.fcontrast &&
      changes.fsaturation) {
      clearTimeout(this.timers.gamma); this.timers.gamma = undefined;
      clearTimeout(this.timers.contrast); this.timers.contrast = undefined;
      clearTimeout(this.timers.saturation); this.timers.saturation = undefined;
      this.changeFiltersForAll();
    } else {
      if (changes.fgamma && changes.fgamma.currentValue !== undefined) {
        if (this.timers.gamma)
          clearTimeout(this.timers.gamma);
        this.timers.gamma = setTimeout(() => {
          this.tweakGamma();
          this.timers.gamma = undefined;
        }, CanvasComponent._tweakDebounceTimeMs);
      }
      if (changes.fcontrast && changes.fcontrast.currentValue !== undefined) {
        if (this.timers.contrast)
          clearTimeout(this.timers.contrast);
        this.timers.contrast = setTimeout(() => {
          this.tweakContrast();
          this.timers.contrast = undefined;
        }, CanvasComponent._tweakDebounceTimeMs);
      }
      if (changes.fsaturation && changes.fsaturation.currentValue !== undefined) {
        if (this.timers.saturation)
          clearTimeout(this.timers.saturation);
        this.timers.saturation = setTimeout(() => {
          this.tweakSaturation();
          this.timers.saturation = undefined;
        }, CanvasComponent._tweakDebounceTimeMs);
      }
    }
    if (changes.finversion && changes.finversion.currentValue !== undefined)
      this.tweakInversion();
    if (changes.fmirror && changes.fmirror.currentValue !== undefined)
      this.setMirror(changes.fmirror.currentValue);

    // Toggled comparison
    if (changes.compareMode && changes.compareMode.currentValue !== undefined) {
      this.changeCanvasSize();
      if (changes.compareMode.currentValue) {
        $('.canvasContainer' + this.canvasId).css('margin', '0 0');
        $('.canvasContainer0').css('float', 'right');
      } else {
        $('.canvasContainer' + this.canvasId).css('margin', '0 auto');
        $('.canvasContainer0').css('float', 'initial');
      }

      /*
      ? This is triggered 2 times during init, we're using this condition
      ? because some elements of listAnimation might be undefined */
      if (this.currentMode === 'video') {
        if (this.listAnimation.get(this.cameraNumber)) {
          // Getting tchek to set vars because they might not have been initialized when second canvas is not visible
          this.setCurrentPicture(this.pictureNumber).then((pictureUrl) => {
            this.renderUid = uid(10)
            this.renderCanvas(pictureUrl, this.renderUid.valueOf(), true);
          }, error => console.error('Cannot setCurrentPicture() 7', error));
        } else {
          console.warn('Canvas ', this.canvasId, ' did not set current picture', this.listAnimation.get(this.cameraNumber));
        }
      }
    }



    // Toggled edit
    if (changes.editMode && changes.editMode.currentValue !== undefined && !changes.editMode.firstChange) {
      this.handleToggleEdit(changes.editMode.currentValue);
    }

    // Toggled annotation
    if (changes.annotateMode && changes.annotateMode.currentValue !== undefined && !changes.annotateMode.firstChange && this.annotateModeSave) {
      this.handleToggleAnnotate(changes.annotateMode.currentValue);
    }

  }

  ngAfterViewInit() {
    this.video = { nativeElement: $('#video' + this.canvasId.toString()).get(0) };
    // console.log('canvasId init', $('#video' + this.canvasId), this.canvasId);
  }

  setCurrentPictureNUM(relativePictureNumber: string | number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.listAnimation.get(this.cameraNumber) === undefined) {
        console.error('this.listAnimation.get(this.cameraNumber) === undefined');
      }
      this.listAnimation.get(this.cameraNumber)
      // console.log('listAnimation element ', this.listAnimation.get(this.cameraNumber));
      // console.log('currentPic before ', this.listAnimation.get(this.cameraNumber).currentPicture);
      // console.log('relative picture number : ', relativePictureNumber);
      // console.log('sbe ', this.deviceId)
      this.listAnimation.get(this.cameraNumber).currentPicture = this.deviceId + '/' + this.listAnimation.get(this.cameraNumber).name +
        '/' + this.cameraNumber + '/' + relativePictureNumber + CanvasComponent._imageExtension;
      // console.log('cvs', this.canvasId, 'setting currentpic ', this.listAnimation.get(this.cameraNumber).currentPicture);
      this.listAnimation.get(this.cameraNumber).miniPicture = this.deviceId + '/' + this.listAnimation.get(this.cameraNumber).name +
        '/mini/' + this.cameraNumber + '/' + relativePictureNumber + CanvasComponent._imageExtension;
      // console.log('currentPic after ', this.listAnimation.get(this.cameraNumber).currentPicture);

      Promise.all([
        this._awsService.generateUrlPromise(
          this.listAnimation.get(this.cameraNumber).currentPicture, this.ipMachine),
        this._awsService.generateUrlPromise(
          this.listAnimation.get(this.cameraNumber).miniPicture, this.ipMachine)
      ]).then(resolvedPromises => {
        this.listAnimation.setCurrentPicture(this.cameraNumber.toString(), resolvedPromises[0]);
        this.listAnimation.setMiniPicture(this.cameraNumber.toString(), resolvedPromises[1]);
        resolve(resolvedPromises[0]);
      }, error => reject(error));
    });
  }


  setCurrentPicture(picturePercent: string | number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.listAnimation.get(this.cameraNumber) === undefined) {
        console.error('this.listAnimation.get(this.cameraNumber) === undefined');
      }
      this.listAnimation.get(this.cameraNumber)
      picturePercent = typeof picturePercent === 'string' ? Number.parseInt(picturePercent) : picturePercent;
      const relativePictureNumber = this.toPictureName(picturePercent);
      // console.log('listAnimation element ', this.listAnimation.get(this.cameraNumber));
      // console.log('currentPic before ', this.listAnimation.get(this.cameraNumber).currentPicture);
      // console.log('relative picture number : ', relativePictureNumber);
      // console.log('sbe ', this.deviceId)
      this.listAnimation.get(this.cameraNumber).currentPicture = this.deviceId + '/' + this.listAnimation.get(this.cameraNumber).name +
        '/' + this.cameraNumber + '/' + relativePictureNumber + CanvasComponent._imageExtension;
      // console.log('cvs', this.canvasId, 'setting currentpic ', this.listAnimation.get(this.cameraNumber).currentPicture);
      this.listAnimation.get(this.cameraNumber).miniPicture = this.deviceId + '/' + this.listAnimation.get(this.cameraNumber).name +
        '/mini/' + this.cameraNumber + '/' + relativePictureNumber + CanvasComponent._imageExtension;
      // console.log('currentPic after ', this.listAnimation.get(this.cameraNumber).currentPicture);

      Promise.all([
        this._awsService.generateUrlPromise(
          this.listAnimation.get(this.cameraNumber).currentPicture, this.ipMachine),
        this._awsService.generateUrlPromise(
          this.listAnimation.get(this.cameraNumber).miniPicture, this.ipMachine)
      ]).then(resolvedPromises => {
        this.listAnimation.setCurrentPicture(this.cameraNumber.toString(), resolvedPromises[0]);
        this.listAnimation.setMiniPicture(this.cameraNumber.toString(), resolvedPromises[1]);
        resolve(resolvedPromises[0]);
      }, error => reject(error));
    });
  }

  changeCanvasSize() {
    console.log('changeCanvasSize canvas')
    if (this.compareMode) {
      this.canvasFullWidth = $('#container-full').width() / 2;
      this.canvasFullHeight = $('#container-full').height() - $('#anim-footer').height();
    } else {
      this.canvasFullWidth = $('#container-full').width();
      this.canvasFullHeight = $('#container-full').height() - $('#anim-footer').height();
    }
    if (this.fcanvas) {
      // ? Maybe rescale img and bcg to fit here
      this.fcanvas.setWidth(this.canvasFullWidth);
      this.fcanvas.setHeight(this.canvasFullHeight);
      this.fcanvas.calcOffset();
    }
    // console.log(this.canvasId, this.canvasFullWidth, 'x', this.canvasFullHeight, this.compareMode);
  }
  setDamageForAnnotation(damage: string, type: number) {
    this._annotationService.setDamageForAnnotation(damage, type);
  }


  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.forEach(sub => {
      if (sub)
        sub.unsubscribe()
    })
  }

  getSize(): { w: number, h: number } {
    let size = { w: 3088, h: 2076 }
    if (this.currentMode === 'video' && this.tchek && this.tchek.camConfig && this.tchek.camConfig[this.cameraNumber]) {
      size.w = this.tchek.camConfig[this.cameraNumber].width
      size.h = this.tchek.camConfig[this.cameraNumber].height
      console.log('get size from db', size, 'video', this.videoResolution, this.fvideo, this.fimage);
    } else if (this.currentMode === 'image' && this.fimage) {
      size.w = this.fimage.getOriginalSize().width
      size.h = this.fimage.getOriginalSize().height
    } else if (this.currentMode === 'image' && this.currentImage && this.currentImage.size) {
      size.w = this.currentImage.size.width
      size.h = this.currentImage.size.height
    } else {
      console.log('NOT get size from db', size, this.fvideo, this.fimage);
    }
    console.log('size : ', size);
    return size
  }

  lastSize = { w: 3088, h: 2076 }
  async renderCanvas(imgSource: string, uidCode: string, clear = false, imageClear = false, imageNumber?) {

    console.log('***** Render ***** ' + uid(25) + new Date(), this.tchek);
    this.updateState(CanvasState.LoadingPicture);
    if (!imgSource) {
      console.warn('renderCanvas() was called with no image source');
      this.updateState(CanvasState.Idle);
      return;
    }

    let size = this.getSize()
    if (this.lastSize.h.valueOf() !== size.h.valueOf() && this.lastSize.w.valueOf() !== size.w.valueOf()) {
      this.lastSize = { w: size.w.valueOf(), h: size.h.valueOf() }
      clear = true
    }


    if (clear && this.fvideo && this.currentMode === 'video') {
      console.log('clear canvas ');
      this.fcanvas.setZoom(1);
      this.fcanvas.clear();
      // Initializing video
      if (this.fcanvas.getWidth() * this.fvideo.getOriginalSize().height > this.fvideo.getOriginalSize().width * this.fcanvas.getHeight())
        this.fvideo.scaleToHeight(this.fcanvas.getHeight());
      else
        this.fvideo.scaleToWidth(this.fcanvas.getWidth());
      this.fcanvas.setBackgroundImage(this.fvideo, this.fcanvas.renderAll.bind(this.fcanvas), {
        originX: 'left',
        originY: 'top',
        crossOrigin: 'anonymous',
        objectCaching: false
      });
      this.fvideo.center();
      this.fvideo.setCoords();
    }

    try {
      if (this.fimage && this.fvideo && this.insideClassificationImage !== true) {
        this.addRoisToCanvas(undefined, imageNumber);
        this.addDetectedParts();
        this.changeFiltersForAll();
      }

      if (this.currentMode === 'image' || this.currentMode === 'underbody' || this.tchek.isUploaded !== true
        || (this.tchek.isHDLocal !== false && environment.isLocal === true)
        || environment.isLocal === false) {
        fabric.Image.fromURL(imgSource, myImgCar => {
          console.log('image hd', imgSource);
          if (myImgCar._element === null) {
            this.annotateModeChange.emit(false)
            this.annotateModeSave = false
            console.error("image hd undefined");
            return this.initImageBd(size)
          } else {
            this.annotateModeChange.emit(true)
            this.annotateModeSave = true
          }

          myImgCar.selectable = false;
          myImgCar.selection = false;
          if (this.currentMode === 'video') {
            myImgCar.width = size.w
            myImgCar.height = size.h
          }

          if (this.fcanvas && this.fcanvas.getWidth() * myImgCar.getOriginalSize().height > myImgCar.getOriginalSize().width * this.fcanvas.getHeight()) {
            myImgCar.scaleToHeight(this.fcanvas.getHeight());
          } else {
            myImgCar.scaleToWidth(this.fcanvas.getWidth());
          }

          if (imageClear) {
            console.log('imageclear');
            this.fcanvas.clear();
            this.fvideo = myImgCar
            this.fcanvas.setBackgroundImage(this.fvideo, this.fcanvas.renderAll.bind(this.fcanvas), {
              originX: 'left',
              originY: 'top',
              crossOrigin: 'anonymous',
              objectCaching: false
            });

            this.fvideo.center();
            this.fvideo.setCoords();
          }

          console.log('code uid ', uidCode, this.renderUid.valueOf());

          if (uidCode !== this.renderUid.valueOf()) return

          this.fcanvas.add(myImgCar)
          myImgCar.center()
          myImgCar.setCoords();

          //this.fcanvas.bringToFront(myImgCar);
          this.fimage = myImgCar;
          if (this.isSuperAdmin) {
            this._annotationService.fimage = myImgCar;
            const relativePictureNumber = this.toPictureName(this.pictureNumber);
            if (!this.annotationLoaded) {
              this.annotationLoaded = true;
              this._annotationService.setCanvasRef(this.fcanvas, relativePictureNumber, this.cameraNumber, this.tchekId, this.currentMode, this.currentImage)
            } else {
              this._annotationService.refresh(this.fcanvas, relativePictureNumber, this.cameraNumber, this.currentMode, this.currentImage, clear)
            }
            this._annotationService.getImageActive()
          }
          this.addRoisToCanvas(undefined, imageNumber);
          this.addDetectedParts();
          this.updateState(CanvasState.Idle);
          this.changeFiltersForAll();


          //load child image
          if (this.currentImage && this.currentImage.child && this.currentImage.child.file.url() !== imgSource) {
            this.renderUid = uid(10)
            this.renderCanvas(this.currentImage.child.file.url(), this.renderUid.valueOf(), false)
          }
        }, { crossOrigin: 'Anonymous' });

      } else {
        console.log('image bd');
        this.initImageBd(size, imageNumber)
      }
    } catch (error) {
      if (this.isSuperAdmin) {
        this._annotationService.fimage = this.fvideo;
        const relativePictureNumber = this.toPictureName(this.pictureNumber);
        if (!this.annotationLoaded) {
          this.annotationLoaded = true;
          this._annotationService.setCanvasRef(this.fcanvas, relativePictureNumber, this.cameraNumber, this.tchekId, this.currentMode, this.currentImage)
        } else {
          this._annotationService.refresh(this.fcanvas, relativePictureNumber, this.cameraNumber, this.currentMode, this.currentImage, clear)
        }
        this._annotationService.getImageActive()
      }
      this.addRoisToCanvas(undefined, imageNumber);
      this.addDetectedParts();
      this.updateState(CanvasState.Idle);
      this.changeFiltersForAll();
    }
  }

  initImageBd(size, imageNumber?) {
    let myImgCar = new fabric.Image(this.video.nativeElement, {
      originX: 'left',
      originY: 'top',
      crossOrigin: 'anonymous',
      objectCaching: false,
      width: size.w,
      height: size.h,
    });


    if (this.fcanvas.getWidth() * myImgCar.getOriginalSize().height > myImgCar.getOriginalSize().width * this.fcanvas.getHeight()) {
      myImgCar.scaleToHeight(this.fcanvas.getHeight());
    } else {
      myImgCar.scaleToWidth(this.fcanvas.getWidth());
    }
    this.fcanvas.add(myImgCar);

    myImgCar.center()
    myImgCar.setCoords();

    myImgCar.selectable = false;
    myImgCar.selection = false;
    //this.fcanvas.bringToFront(myImgCar);
    this.fimage = myImgCar;
    if (this.isSuperAdmin) {
      this._annotationService.fimage = myImgCar;
      const relativePictureNumber = this.toPictureName(this.pictureNumber);
      if (!this.annotationLoaded) {
        this.annotationLoaded = true;

        this._annotationService.setCanvasRef(this.fcanvas, relativePictureNumber, this.cameraNumber, this.tchekId, this.currentMode, this.currentImage)
      } else {
        this._annotationService.refresh(this.fcanvas, relativePictureNumber, this.cameraNumber, this.currentMode, this.currentImage)

      }
      this._annotationService.getImageActive()
    }
    this.addRoisToCanvas(undefined, imageNumber);
    this.addDetectedParts();
    this.updateState(CanvasState.Idle);
    this.changeFiltersForAll();
  }

  seek(videoNumber: number) {
    // this._annotationService.refreshAnnotation(relativePictureNumber)
    // console.log('seek');
    this.annotateModeChange.emit(false)
    this.annotateModeSave = false
    //this._annotationService.clearAnnotations()
    if (this.video.nativeElement.readyState === HTMLMediaElement.HAVE_NOTHING)
      return this.video.nativeElement.load();
    if (!(this.video.nativeElement.currentTime === undefined) || !(this.video.nativeElement.currentTime === NaN)) {
      console.log('set video time ', (videoNumber * this.video.nativeElement.duration) / 100);
      this.video.nativeElement.currentTime = (videoNumber * this.video.nativeElement.duration) / 100;
    } else
      console.warn('HTMLMedialElement.currentTime is undefined');

    // this.fcanvas.requestRenderAll();
  }

  // Renders the frame of the video after we sought to the desired time
  handleVideoSeeked = () => {
    // console.log('Render seeked with state ', this.video.nativeElement.readyState);
    /* let fobjects;
    if ((fobjects = this.fcanvas.getObjects()).length > 0) {
      this.fcanvas.remove(...fobjects);
    } */
    // /this.fcanvas.clearTop();
    //   console.log('video adding rois');
    this.addRoisToCanvas(this.cameraNumber.toString(), this.toPictureName(this.videoNumber));
    this.changeFiltersForAll();
    this.fcanvas.renderAll();
  }

  // Renders the frame of the video after we sought to the desired time w/o bringing the video to the front
  handleVideoSeekedSilent = () => {
    // console.log('Silently render seeked ');
    this.fcanvas.renderAll();
    this.video.nativeElement.addEventListener('seeked', this.handleVideoSeeked, false);
  }

  handleVideoReady = (e) => {
    this.video.nativeElement.addEventListener('seeked', this.handleVideoSeekedSilent, { once: true });
    this.seek(this.pictureNumber);
  }

  handleVideoLoaded = (e, init = false) => {
    if (this.fcanvas) this.fcanvas.clear()

    if (e !== undefined) {
      this.videoResolution = {
        width: e.target.videoWidth,
        height: e.target.videoHeight
      }
    } else {
      console.log('no video');
      this.videoResolution = {
        width: this.getSize().w,
        height: this.getSize().h
      }
    }
    console.log('video loaded ', e, this.videoResolution);

    //  console.log('this.videoResolution : ', this.videoResolution)
    this.video.nativeElement.setAttribute('height', this.videoResolution.height.toString());
    this.video.nativeElement.setAttribute('width', this.videoResolution.width.toString());


    this.fvideo = new fabric.Image(this.video.nativeElement, {
      objectCaching: false,
      crossOrigin: 'anonymous'
    });

    this.fvideo.selectable = false;
    this.fvideo.selection = false;
    // Initializing video

    if (this.fcanvas.getWidth() * this.fvideo.getOriginalSize().height > this.fvideo.getOriginalSize().width * this.fcanvas.getHeight())
      this.fvideo.scaleToHeight(this.fcanvas.getHeight());
    else
      this.fvideo.scaleToWidth(this.fcanvas.getWidth());


    this.fcanvas.add(this.fvideo);
    this.fcanvas.sendToBack(this.fvideo);
    this.fcanvas.setBackgroundImage(this.fvideo, this.fcanvas.renderAll.bind(this.fcanvas), {
      originX: 'left',
      originY: 'top',
      crossOrigin: 'anonymous',
      objectCaching: false
    });

    this.fvideo.center();
    this.fvideo.setCoords();

    // console.log('rendering listAnimation[', this.cameraNumber, '] = ', this.listAnimation.get(this.cameraNumber));
    this.renderUid = uid(10)
    if (init)
      this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture, this.renderUid.valueOf());
  }

  // Set filters for images
  changeFiltersForAll() {
    console.log('change filter');
    if (!this.fcanvas)
      return;
    this.fcanvas.getObjects('image').forEach((img: fabric.Image) => {
      // console.log(this.canvasId, 'changingFiltersForAll : imgElement', img.getElement(),
      //   'instanceof HTMLImage?', img.getElement() instanceof HTMLImageElement);
      img.filters[0] = new fabric.Image.filters.Gamma({ gamma: [this.fgamma, this.fgamma, this.fgamma] });
      img.filters[1] = new fabric.Image.filters.Contrast({ contrast: this.fcontrast });
      img.filters[2] = new fabric.Image.filters.Saturation({ saturation: this.fsaturation });
      if (this.finversion)
        img.filters[3] = new fabric.Image.filters.Invert();
      else
        img.filters[3] = null;
      if (this.fmirror)
        img.flipX = true;
      else
        img.flipX = false;

      img.applyFilters();
    });
    // set filters for bcg
    if (this.fcanvas && this.fcanvas.backgroundImage) {
      this.fcanvas.backgroundImage.filters[0] = new fabric.Image.filters.Gamma({ gamma: [this.fgamma, this.fgamma, this.fgamma] });
      this.fcanvas.backgroundImage.filters[1] = new fabric.Image.filters.Contrast({ contrast: this.fcontrast });
      this.fcanvas.backgroundImage.filters[2] = new fabric.Image.filters.Saturation({ saturation: this.fsaturation });
      if (this.finversion)
        this.fcanvas.backgroundImage.filters[3] = new fabric.Image.filters.Invert();
      else
        this.fcanvas.backgroundImage.filters[3] = null;
      if (this.fmirror)
        this.fcanvas.backgroundImage.flipX = true;
      else
        this.fcanvas.backgroundImage.flipX = false;

      this.fcanvas.backgroundImage.applyFilters();
      this.fcanvas.zoomToPoint(new fabric.Point(0, 0), this.fcanvas.getZoom());
    }
  }

  // Set force to true or false to enforce that value
  favThisPicture() {
    this._tchekService
      .favPicture(
        parseInt(this.toPictureName(this.pictureNumber)),
        this.cameraNumber.toString(),
        this.tchekId,
        true,
        this._notificationService.success('Favoris', 'Cette image a bien été placée dans vos favoris', {
          timeOut: 4500,
          showProgressBar: true,
          pauseOnHover: true,
          clickToClose: true,
          maxLength: 50
        })
      )
      .then(
        () => { },
        () => console.error('Failed setting picture to favorites')
      );
  }

  notInplayerImages(): boolean {
    let imagenotinPlayer = true
    if (this.currentMode !== 'video' && (this.insideClassificationImage || this.tchek.type < 2))
      imagenotinPlayer = false
    return imagenotinPlayer
  }

  // Add ROIs to canvas
  addRoisToCanvas(folder?: string, picture?: number | string) {
    let roisInThisPic: Array<Parse.Object>;

    if (this.currentMode === 'video') {
      if (folder !== undefined && picture !== undefined)
        roisInThisPic = this.rois.getPictureRois(folder, picture);
      else if (picture)
        roisInThisPic = this.rois.getPictureRois(this.cameraNumber.toString(), picture);
      else
        roisInThisPic = this.rois.getPictureRois(this.cameraNumber.toString(), this.toPictureName(this.pictureNumber));
    } else {
      roisInThisPic = this.rois.getPictureRoisFromImage(this.currentImage);
    }

    //    console.log("roisInThisPic", roisInThisPic)
    // console.log('minprobvehicle', this.minProbVehicle, 'admin', this.isSuperAdmin);
    // Filter by ROI score if set
    if (this.minProbVehicle >= 0)
      roisInThisPic = roisInThisPic.filter(r => (r.get('score') !== undefined && r.get('score') >= this.minProbVehicle));

    //Filter ROI for canDetection
    if (this.canDetection === false)
      roisInThisPic = roisInThisPic.filter(r => (r.get('isAuto') !== true));

    // Clearing old ROIs
    if (this.fcanvas && this.fcanvas.getObjects('group'))
      this.fcanvas.getObjects('group').forEach((fgroup) => {
        //SBE

        let type = this.tchek.inspectedByAlto || this.tchek.resultAltoApi ? 'rect' : 'circle'

        if (fgroup.getObjects(type).length > 0) {
          this.fcanvas.remove(fgroup);
        }
      });

    // Adding ROIs to canvas if any
    const colorRoiAuto = this.style.damageColor // unicar
      ? this.style.damageColor
      : 'white';

    if (roisInThisPic && this.fimage && this.hideDamages === false && this.notInplayerImages())
      for (let i = 0; i < roisInThisPic.length; i++) {
        if (!this._roiService.isDamageSelected(roisInThisPic[i].get('damagePtr')) && roisInThisPic[i].get('isProjected'))
          continue;
        if (this._roiService.isDamageHighlighted(roisInThisPic[i].get('damagePtr')) && this._roiService.isRoiHighlighted(roisInThisPic[i]) && roisInThisPic[i].get('isProjected') && !this.isSuperAdmin)
          continue;
        if (!roisInThisPic[i].get('damagePtr'))
          continue;

        if (!this.activeRoiAdminDrawer)
          if (roisInThisPic[i].get('damagePtr').get('isDeleted'))
            if (roisInThisPic[i].get('damagePtr').get('isDeleted') == true)
              continue;
        let color = this.style.newDamageColor ? this.style.newDamageColor : 'red';
        color = roisInThisPic[i].get('isAuto') ? colorRoiAuto : color;
        const roiCircle = new fabric.Circle({
          id: i,
          left: 0,
          top: 0,
          fill: 'transparent',
          radius:
            roisInThisPic[i].get('radius') * this.fimage.getScaledWidth(),
          strokeWidth: 5,
          strokeDashArray:
            this._roiService.isDamageHighlighted(roisInThisPic[i].get('damagePtr'))
              && roisInThisPic[i].get('isProjected') ?
              [10, 5] : undefined,
          stroke: roisInThisPic[i].get('isAuto') ? colorRoiAuto : color,
          selectable: false,
          originX: 'center',
          originY: 'center',
          draggable: false,
          lockRotation: true,
          hasControls: false
        });

        let colorFill = 'rgb(105,183,182)'
        if (this.isSuperAdmin && roisInThisPic[i].get('damagePtr').get('parentPtr') === undefined && roisInThisPic[i].get('damagePtr').get('isAuto') === true) colorFill = 'rgb(0, 144, 211)'  //no parent
        if (this.isSuperAdmin && roisInThisPic[i].get('damagePtr').get('isDeleted')) colorFill = 'rgb(131, 0, 0)'  //is deleted

        let yolo = ''
        if (roisInThisPic[i].get('validationScore'))
          yolo = ` (yolo : ${(roisInThisPic[i].get('validationScore') * 100).toFixed(1)})`
 
           let textValue = ''
          if (this.isSuperAdmin) {
            textValue = `${this._vehicleDamagePipe
              .transform(roisInThisPic[i].get('damagePtr').get('type'))} ${roisInThisPic[i]
                .get('damagePtr').get('uid')}`;
            if (roisInThisPic[i].get('score') !== undefined && this._parametersService.isSuperAdmin)
              textValue += ` (${(roisInThisPic[i].get('score') * 100).toFixed(1)}%) (${roisInThisPic[i].get('damagePtr').get('detectionCount')}x)${yolo}`;
          }
 
          const roiText = new fabric.Text(textValue, {
            fontSize: 16,
            fontFamily: 'Open Sans',
            fill: 'white',
            fontWeight: 'bold',
            originX: 'center',
            originY: 'bottom',
            draggable: false,
            selectable: false,
            lockRotation: true,
            hasControls: false,
            left: 0,
            top:
              - roisInThisPic[i].get('radius') * this.fimage.getScaledWidth() -
              23,
            // shadow: 'rgba(0,0,0,0.6) 2px 2px 1px'
          });

          const roiTextPart = new fabric.Text(this._damageLocationPipe.transform(roisInThisPic[i].get('damagePtr').get('location')), {
            fontSize: 16,
            fontFamily: 'Open Sans',
            fill: 'white',
            fontWeight: 'bold',
            originX: 'center',
            originY: 'bottom',
            draggable: false,
            selectable: false,
            lockRotation: true,
            hasControls: false,
            left: 0,
            top:
              - roisInThisPic[i].get('radius') * this.fimage.getScaledWidth() - 8,
            // shadow: 'rgba(0,0,0,0.6) 2px 2px 1px'
          });

          const roiTextBox = new fabric.Rect({
            width: (roiText.getScaledWidth() > roiTextPart.getScaledWidth() ? roiText.getScaledWidth() : roiTextPart.getScaledWidth()) + 32 + 16,
            height: roiText.getScaledHeight() + 10,
            cornerStyle: 'circle',
            strokeLineJoin: 'round',
            strokeWidth: 10,
            stroke: colorFill,
            fill: colorFill,
            originX: 'center',
            originY: 'bottom',
            left: roiText.getCenterPoint().x,
            top: roiText.top + 16
          });
          const roiTextNotch = new fabric.Triangle({
            width: 12,
            height: 6,
            originX: 'center',
            originY: 'bottom',
            fill: colorFill,
            left: roiTextBox.left,
            top: roiTextBox.top - 1,
            angle: 180
          });
          //SBE

          let groupVectors = [roiTextNotch, roiCircle, roiTextBox, roiText, roiTextPart]
          let left = roisInThisPic[i].get('centerX') * this.fimage.getScaledWidth() + roiCircle.strokeWidth + this.fimage.left
          let top = (roisInThisPic[i].get('centerY') + (roiCircle.radius / this.fimage.getScaledHeight()))
            * this.fimage.getScaledHeight() + roiCircle.strokeWidth + this.fimage.top
          let originY = 'bottom'

 
          if (this.tchek.inspectedByAlto || this.tchek.resultAltoApi) {
 

            left = roisInThisPic[i].get('centerX') * this.fimage.getScaledWidth() + this.fimage.left + 2
            top = (roisInThisPic[i].get('centerY')) * this.fimage.getScaledHeight() + this.fimage.top + 2
            originY = 'center'

            let colorBox

            if (roisInThisPic[i].get('damagePtr').get('type') == "scratch") {
              colorBox = 'rgb(105,249,36)'
            } else if (roisInThisPic[i].get('damagePtr').get('type') == "dent") {
              colorBox = 'rgb(166,31,255)'
            } else {
              colorBox = 'rgb(21,70,255)'
            }

            if (roisInThisPic[i].get('damagePtr').get('isDeleted')) {
              colorBox = 'red'
            }

            let coeff = this.fimage.getScaledWidth() / this.fimage.getOriginalSize().width

            let backgroundColor = ''
            if (roisInThisPic[i].get('damagePtr').get('inspected')) backgroundColor = colorBox

            const roiBoundingBox = new fabric.Rect({
              width: roisInThisPic[i].get('width') < 1 ? (roisInThisPic[i].get('width') * this.fimage.getScaledWidth()) : (roisInThisPic[i].get('width') * coeff),
              height: roisInThisPic[i].get('height') < 1 ?
                (roisInThisPic[i].get('height') * this.fimage.getScaledHeight()) :
                (roisInThisPic[i].get('height') * coeff),
              cornerStyle: 'circle',
              strokeLineJoin: 'round',
              strokeWidth: 2,
              stroke: colorBox,
              hasBorder: true,
              fill: 'transparent',
              originX: 'center',
              originY: 'center',
              backgroundColor: backgroundColor,
              opacity: roisInThisPic[i].get('damagePtr').get('inspected') ? 0.3 : 1,
              strokeDashArray: roisInThisPic[i].get('damagePtr').get('ignoreIt') ? [5, 5] : [0, 0],

            });
            groupVectors = [roiBoundingBox]
 
          this.fcanvas.add(
            new fabric.Group(groupVectors, {
              left: left,
              top: top,
              originX: 'center',
              originY: originY,
              lockRotation: true,
              hasControls: false,
              selectable: this.editMode,
              evented: this.editMode,
              parseId: roisInThisPic[i].id,
              damageId: roisInThisPic[i].get('damagePtr').id,
              isAuto: roisInThisPic[i].get('isAuto'),
              isValidated: roisInThisPic[i].get('isValidated'),
              // opacity: roisInThisPic[i].get('isAuto') && roisInThisPic[i].get('isValidated') ||
              opacity: ((this._roiService.isDamageHighlighted(roisInThisPic[i].get('damagePtr'))
                && this._roiService.isRoiHighlighted(roisInThisPic[i]))
                || (roisInThisPic[i].get('damagePtr')
                  && roisInThisPic[i].get('damagePtr').get('parentPtr')
                  && roisInThisPic[i].get('damagePtr').get('parentPtr').get('tchekPtr')
                  && this._roiService.isDamageHighlightedCompare(roisInThisPic[i].get('damagePtr'))
                  && this.tchekId === roisInThisPic[i].get('damagePtr').get('parentPtr').get('tchekPtr').id
                )
              ) ? 0.9 : 0.1
            })
          );
        } else {
          //console.log("roisInThisPic[i].get('damagePtr')",roisInThisPic[i],i)
          let textValue = `${this._vehicleDamagePipe
            .transform(roisInThisPic[i].get('damagePtr').get('type'))} ${roisInThisPic[i]
              .get('damagePtr').get('uid')}`;
          if (roisInThisPic[i].get('score') !== undefined && (this._parametersService.isSuperAdmin || this._parametersService.canSeeConfidence ))
            textValue += ` (${(roisInThisPic[i].get('score') * 100).toFixed(1)}%) (${roisInThisPic[i].get('damagePtr').get('detectionCount')}x)`;
          const roiText = new fabric.Text(textValue, {
            fontSize: 16,
            fontFamily: 'Open Sans',
            fill: 'white',
            fontWeight: 'bold',
            originX: 'center',
            originY: 'bottom',
            draggable: false,
            selectable: false,
            lockRotation: true,
            hasControls: false,
            left: 0,
            top:
              - roisInThisPic[i].get('radius') * this.fimage.getScaledWidth() -
              16,
            // shadow: 'rgba(0,0,0,0.6) 2px 2px 1px'
          });

          const roiTextBox = new fabric.Rect({
            width: roiText.getScaledWidth() + 32 + 16,
            height: roiText.getScaledHeight() + 8,
            cornerStyle: 'circle',
            strokeLineJoin: 'round',
            strokeWidth: 10,
            stroke: colorFill,
            fill: colorFill,
            originX: 'center',
            originY: 'bottom',
            left: roiText.getCenterPoint().x,
            top: roiText.top + 8
          });
          const roiTextNotch = new fabric.Triangle({
            width: 12,
            height: 6,
            originX: 'center',
            originY: 'bottom',
            fill: colorFill,
            left: roiTextBox.left,
            top: roiTextBox.top - 1,
            angle: 180
          });
          this.fcanvas.add(
            new fabric.Group([roiTextNotch, roiCircle, roiTextBox, roiText], {
              left:
                roisInThisPic[i].get('centerX') * this.fimage.getScaledWidth() + roiCircle.strokeWidth + this.fimage.left,
              top:
                (roisInThisPic[i].get('centerY') + (roiCircle.radius / this.fimage.getScaledHeight()))
                * this.fimage.getScaledHeight() + roiCircle.strokeWidth + this.fimage.top,
              originX: 'center',
              originY: 'bottom',
              lockRotation: true,
              hasControls: false,
              selectable: this.editMode,
              evented: this.editMode,
              parseId: roisInThisPic[i].id,
              damageId: roisInThisPic[i].get('damagePtr').id,
              isAuto: roisInThisPic[i].get('isAuto'),
              isValidated: roisInThisPic[i].get('isValidated'),
              // opacity: roisInThisPic[i].get('isAuto') && roisInThisPic[i].get('isValidated') ||
              opacity: ((this._roiService.isDamageHighlighted(roisInThisPic[i].get('damagePtr'))
                && this._roiService.isRoiHighlighted(roisInThisPic[i]))
                || (roisInThisPic[i].get('damagePtr')
                  && roisInThisPic[i].get('damagePtr').get('parentPtr')
                  && roisInThisPic[i].get('damagePtr').get('parentPtr').get('tchekPtr')
                  && this._roiService.isDamageHighlightedCompare(roisInThisPic[i].get('damagePtr'))
                  && this.tchekId === roisInThisPic[i].get('damagePtr').get('parentPtr').get('tchekPtr').id
                )
              ) ? 0.9 : 0.1
            })
          );
        }
	

      }
    return roisInThisPic;
  }

  // Removes ROIs from Parse and from canvas
  removeRoi(roiGroups) {
    this._roiService.deletePictureRois(roiGroups).then(
      () => {
        for (let i = 0; i < roiGroups.length; i++) {
          this.rois.removeFromFGroup(roiGroups[i], this.tchek.inspectedByAlto || this.tchek.resultAltoApi);
          this.fcanvas.fxRemove(roiGroups[i]);
        }

      },
      error => console.error('Could not delete ROI ', error.code, error.message)
    );
  }

  public saveRoi(modalData) {
    const roi = new Roi();
    roi.centerX = (this.circle.left - this.fvideo.left) / this.fvideo.getScaledWidth();
    roi.centerY = (this.circle.top - this.fvideo.top) / this.fvideo.getScaledHeight();
    roi.radius = this.circle.radius / this.fvideo.getScaledWidth();
    roi.tchek = new Tchek(this.tchekId);
    roi.folder = this.listAnimation.get(this.cameraNumber).folder;
    roi.picture = parseInt(this.toPictureName(this.pictureNumber), 10);
    roi.type = modalData.selectedType;
    roi.location = modalData.selectedLocation;
    roi.comment = modalData.comment;
    roi.severity = modalData.selectedSeverity;

    roi.width = this.circle.width;
    roi.height = this.circle.height;
    roi.vehicleId = this.vehicleId;
    // console.log('saving ', roi);
    if (this._parametersService.isSuperAdmin) {
      roi.isAuto = modalData.isROIAuto;
    } else {
      roi.isAuto = false;
    }
    // Adding folderPtr
    this._folderService.getByTchek(this.tchekId).then(folders => {
      roi.folderPtr = folders.find(f => f.name === roi.folder).getParseInstance();
      // Saving ROI
      this._roiService.setPictureRoi(roi).then(
        (savedDamage: Parse.Object) => {
          savedDamage.get('roiPtr').fetchWithInclude(['tchekPtr', 'damagePtr', 'folderPtr', 'imagePtr'])
            .then((fetchedRoi: Parse.Object) => {
              this.renderUid = uid(10)
              this.rois.array.push(fetchedRoi);
              this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture, this.renderUid.valueOf());
            });
        },
        error => {
          console.error('Cannot save ROI to Parse ', error);
        }
      );
    });
    // TODO: implement indenpendent favorite after comparison done
    // ? Check out favAccordingly() in Animation to get an idea
    if (modalData.alsoFavCheckbox) this.favThisPicture();
  }

  public cancelRoi = function () {
    this.fcanvas.fxRemove(this.circle);
    this.circle = undefined;
  };

  public editRoi(modalData) {
    const roiToEdit = this._roiService.getRoiToEdit();
    roiToEdit.get('damagePtr').set('type', modalData.selectedType);
    roiToEdit.get('damagePtr').set('location', modalData.selectedLocation);
    roiToEdit.set('comment', modalData.comment);
    roiToEdit.get('damagePtr').set('severity', modalData.selectedSeverity);
    if (modalData.isAuto) {
      roiToEdit.set('isAuto', modalData.isAuto);
      roiToEdit.set('isValidated', modalData.isValidated);
    }
    if (modalData.isDeleted) {
      roiToEdit.set('isDeleted', true);
      roiToEdit.get('damagePtr').set('isDeleted', true);
    }
    // console.log('updatinf ROI ', roiToEdit);
    this._roiService
      .updateRoi(roiToEdit)
      .then(
        roiUpdated => {
          // console.log('roiUpdated after save emit ', roiUpdated);
          // Clear ROI to edit
          // this._roiService.setRoiToEdit(); // removes autoROI data in edit modal when approved
          // Update ROIs matrix
          this.fcanvas.discardActiveObject();
          if (!roiUpdated.get('isDeleted'))
            this.rois.updateRoi(roiUpdated);
          else
            this.rois.remove(roiUpdated.id);
          // Update the canvas
          this.renderUid = uid(10)
          this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture, this.renderUid.valueOf());
        },
        () => console.error('Could not update ROI')
      );
    if (modalData.alsoFavCheckbox) this.favThisPicture();
  }

  public cancelEditRoi = function () {
    this._roiService.setRoiToEdit();
    this.fcanvas.discardActiveObject();
  };

  public removeRoisByDamage(damage: Damage) {

    var newRois = []
    this.rois.array.forEach(r => {
      if (r.get('damagePtr')) {
        if (r.get('damagePtr').id !== damage.id) {
          newRois.push(r)
        }
      }
    });
    this.rois.array = newRois
    this.renderUid = uid(10)
    this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture, this.renderUid.valueOf());
  }

  beginImagePanningHandler = function (opt) {
    if (!this.fcanvas.imagePanActive) {
      if (!(opt && opt.e && opt.e.ctrlKey))
        return;
    }
    const evt = opt.e;
    console.log('drag 00', opt);
    // Moving the entire image
    this.fcanvas.isDragging = true;
    this.fcanvas.lastPosX = evt.clientX;
    this.fcanvas.lastPosY = evt.clientY;
  };

  endImagePanningHandler = function (opt) {
    if (!this.fcanvas.imagePanActive) {
      if (!(opt && opt.e && opt.e.ctrlKey))
        return;
    }
    this.fcanvas.isDragging = false; // Stopped dragging the image
  };

  // Enable and disable image panning (as in when you press Edit)
  enableImageMovement = () => {
    if (!this.isMobile) this.fcanvas.imagePanActive = true;
  }

  disableImageMovement() { this.fcanvas.imagePanActive = false; }

  toggleAutoRoisMasks(enable?: boolean) {
    if (enable || (enable === undefined && !this.autoRoiMasksEnabled)) {
      this.autoRoiMasksEnabled = true;
      const points = [];
      this._roiService.getPictureRois(this.tchekId, this.cameraNumber.toString(), parseInt(this.toPictureName(this.pictureNumber))).then(rois => {
        rois.forEach(r => {
          if (r.get('mask') && r.get('mask').x.length > 2) {
            points.push(this._roiService.calcRelativePoints(this.fcanvas, this._roiService.transformMaskToPoints(r.get('mask')), this.getSize()));
          }
        });
        Promise.all(points).then((relativePoints) => {
          const polys = [];
          relativePoints.forEach(points => {
            polys.push(new fabric.iPolygon(points, this._roiService._maskPolyOptions));
          });
          // console.log('masks', polys);
          this.fcanvas.add(...polys);
        });
      });
    } else {
      this.autoRoiMasksEnabled = false;
      const masks = this.fcanvas.getObjects().filter(o => (o.kind === 'mask'));
      console.log('removing masks', masks)
      this.fcanvas.remove(...masks);
      this.fcanvas.renderAll();
    }
  }

  updateState(newState: CanvasState): EventEmitter<CanvasState> {
    this.stateValue = newState;
    this.state.emit(this.stateValue);
    return this.state;
  }

  toPictureName(picturePercent: number, totalPictures?: number): string {
    if (this.currentMode === 'image') return undefined
    /* console.log('cam name ', this.cameraNumber, ' list ', this.listAnimation.array,
  ' this camera ', this.listAnimation.get(this.cameraNumber)); */
    const total = (totalPictures !== undefined ?
      totalPictures : (this.listAnimation.get(this.cameraNumber)
        ? this.listAnimation.get(this.cameraNumber).totalPictures : undefined));
    if (total === undefined)
      console.warn('Both argument totalPictures and listCamera.totalPictures are undefined');

    return (Math.floor((total / 100) * picturePercent)).toString();    // Minus 1 to fix last image being blank
  }

  // Handlers for ROI drawing on the canvas
  drawingHandler = opt => {
    console.log('drawing h', this.isMobile, opt)
    if (opt && opt.e && opt.e.ctrlKey)
      return;
    const evt = opt.e;
    const target = opt.target;
    if (target) {
      if (target.type === 'image') {
        // Setting this canvas as currently editing an ROI
        this.editingRoi.emit(this.canvasId);
        // Drawing new ROI
        this.isDrawing = true;
        const pointer = this.fcanvas.getPointer(evt);
        console.log('pointer img : ', pointer)
        this.origX = pointer.x;
        this.circle = new fabric.Circle({
          left: pointer.x,
          top: pointer.y,
          fill: 'transparent',
          radius: 1,
          strokeWidth: 2,
          stroke: this.style.newDamageColor ? this.style.newDamageColor : 'red',
          selectable: false,
          originX: 'center',
          originY: 'center'
        });
        this.fcanvas.add(this.circle);
      }
    } else {
      this.editingRoi.emit(this.canvasId);
      // Drawing new ROI
      this.isDrawing = true;
      const pointer = this.fcanvas.getPointer(evt);
      console.log('pointer : ', pointer)

      this.origX = pointer.x;
      this.circle = new fabric.Circle({
        left: pointer.x,
        top: pointer.y,
        fill: 'transparent',
        radius: 1,
        strokeWidth: 2,
        stroke: 'red',
        selectable: false,
        originX: 'center',
        originY: 'center'
      });
      this.fcanvas.add(this.circle);
    }
  }

  onMouseMove = o => {
    if (!this.isDrawing) return;
    const pointer = this.fcanvas.getPointer(o.e);
    this.circle.set({ radius: Math.abs(this.origX - pointer.x) });
    this.fcanvas.requestRenderAll();
  }

  onMouseUp = () => {
    if (this.isDrawing) {
      this.isDrawing = false;
      if (this.circle.radius <= 1) this.cancelRoi();
      else {
        let picture = parseInt(this.toPictureName(this.pictureNumber), 10);
        let data = {
          type: 'create',
          circle: this.circle,
          cirlcleCenterX: (this.circle.left - this.fvideo.left) / this.fvideo.getScaledWidth(),
          cirlcleCenterY: (this.circle.top - this.fvideo.top) / this.fvideo.getScaledHeight(),
          cirlcleRadius: this.circle.radius / this.fvideo.getScaledWidth(),
          picture,
          currentMode: this.currentMode,
          image: this.currentImage ? this.currentImage.id : undefined,
          vehicleId: this.vehicleId,
          listAnimation: this.listAnimation,
          pictureNumber: this.pictureNumber,
          cameraNumber: this.cameraNumber,
          fvideo: this.fvideo,
          tchekId: this.tchekId,
          rois: this.rois,
          fcanvas: this.fcanvas
        }
        this._damageService.modalOpen(data)
        // $('#newRoiModal').modal({ backdrop: 'static', keyboard: false });
      }
    }
  }


  // Handler for Edit button
  handleToggleEdit(newEditMode: boolean) {
    if (newEditMode) {
      this.disableImageMovement();
      this.fcanvas.defaultCursor = 'copy';
      this.fcanvas.setCursor('copy');
      // Make objects selectable unless it's the background image
      for (let i = 0; i < this.fcanvas.getObjects().length; ++i) {
        if (this.fcanvas.item(i).type !== 'image') {
          this.fcanvas.item(i).selectable = true;
          this.fcanvas.item(i).evented = true;
        }
      }
      // Start listening to mouse event when clicked on button draw (.isroi class)
      this.fcanvas.on('mouse:down', this.drawingHandler);
      this.fcanvas.on('mouse:move', this.onMouseMove);
      this.fcanvas.on('mouse:up', this.onMouseUp);
    } else {
      this.enableImageMovement();
      this.fcanvas.defaultCursor = 'move';
      this.fcanvas.setCursor('move');
      for (let i = 0; i < this.fcanvas.getObjects().length; ++i) {
        if (this.fcanvas.item(i).type !== 'image') {
          this.fcanvas.item(i).selectable = false;
          this.fcanvas.item(i).evented = false;
        }
      }
      this.fcanvas.off('mouse:down', this.drawingHandler);
      this.fcanvas.off('mouse:move', this.onMouseMove);
      this.fcanvas.off('mouse:up', this.onMouseUp);
    }
  }

  showDate: boolean = true
  handleToggleAnnotate(newAnnotateMode: boolean) {
    this.showDate = !newAnnotateMode
    this._annotationService.setPolygonsSelectable(newAnnotateMode);
    if (newAnnotateMode) {
      this.disableImageMovement();
      this.fcanvas.defaultCursor = 'cell';
      this.fcanvas.setCursor('cell');
      this.fcanvas.on('object:moving', this._annotationService.objectMovingHandler);
      this.fcanvas.on('mouse:down', this._annotationService.mouseDownHandler);
      this.fcanvas.on('mouse:wheel', this._annotationService.mouseWheelHandler);
      this.fcanvas.on('mouse:up', this._annotationService.mouseUpHandler);
      $(document).on('keyup', this.fcanvas, this._annotationService.keyUpHandler);
      // Listening for ROIs movement
      this.fcanvas.off('object:moved', this.handleRoiMoved);
    } else {
      this.fcanvas.off('object:moving', this._annotationService.objectMovingHandler);
      this.fcanvas.off('mouse:down', this._annotationService.mouseDownHandler);
      this.fcanvas.off('mouse:wheel', this._annotationService.mouseWheelHandler);
      this.fcanvas.off('mouse:up', this._annotationService.mouseUpHandler);
      $(document).off('keyup', this._annotationService.keyUpHandler);
      // Listening for ROIs movement
      this.fcanvas.on('object:moved', this.handleRoiMoved);
      // Deselect annotations
      this.fcanvas.discardActiveObject();
      this.fcanvas.renderAll();
      if (this.editMode === false) {
        this.enableImageMovement();
        this.fcanvas.defaultCursor = 'move';
        this.fcanvas.setCursor('move');
      }
    }
    console.log('newAnnotateMode', newAnnotateMode)
  }

  tweakGamma() {
    // console.log('changing gamma ', this.fgamma);
    // this.fgamma = $(event.target).val();
    this.changeFilter(new fabric.Image.filters.Gamma({
      gamma: [this.fgamma, this.fgamma, this.fgamma]
    }), 0);
  }

  tweakContrast() {
    // console.log('changing contrast ', this.fcontrast);
    // this.fcontrast = $(event.target).val();
    this.changeFilter(new fabric.Image.filters.Contrast({
      contrast: this.fcontrast
    }), 1);
  }

  tweakSaturation() {
    // console.log('changing saturation ', this.fsaturation);
    // this.fsaturation = $(event.target).val();
    this.changeFilter(new fabric.Image.filters.Saturation({
      saturation: this.fsaturation
    }), 2);
  }

  tweakInversion() {
    if (this.finversion) {
      // this.finversion = true;
      this.changeFilter(new fabric.Image.filters.Invert(), 3);
    } else {
      // this.finversion = false;
      this.changeFilter(null, 3);
    }
  }

  setMirror(enable?: boolean) {
    if (!this.fcanvas)
      return;
    if (enable) {
      this.fcanvas.getObjects('image').forEach(o => {
        o.flipX = true;
      });
      this.fcanvas.renderAll();
    } else {
      this.fcanvas.getObjects('image').forEach(o => {
        o.flipX = false;
      });
      this.fcanvas.renderAll();
    }
  }

  changeFilter(val: number, index) {
    if (!this.fcanvas || !this.fcanvas.backgroundImage)
      return;
    // console.log('cvs ', this.canvasId, 'objects ', this.fcanvas.getObjects());
    this.fcanvas.getObjects('image').forEach(img => {
      img.filters[index] = val;
      img.applyFilters();
    });
    this.fcanvas.backgroundImage.filters[index] = val;
    this.fcanvas.backgroundImage.applyFilters();
    this.fcanvas.zoomToPoint({ x: 0, y: 0 }, this.fcanvas.getZoom());
  }

  addDetectedParts() {
    if (!this.detectionData || !this.partsMode)
      return;

    const fAllParts = [];
    const detectionFolder = this.detectionData.getFolder(this.cameraNumber);
    if (!detectionFolder)
      return;

    const detectionPicture = detectionFolder.getPictureData(this.toPictureName(this.pictureNumber));
    // console.log('detection for this picture ', detectionPicture);
    if (!detectionPicture)
      return;
    detectionPicture.pieces.forEach((part) => {
      const fPartPolygons = [];
      let partColor: string;
      switch (part.getType()) {
        case 'PRC':
          partColor = 'rgba(96, 162, 0, 1)';
          break;
        case 'RTR':
          partColor = 'rgba(232, 162, 0, 1)';
          break;
        case 'PLI':
          partColor = 'rgba(232, 162, 233, 1)';
          break;
        case 'PRT':
          partColor = 'rgba(129, 229, 233, 1)';
          break;
        case 'ROU':
          partColor = 'rgba(146, 89, 176, 1)';
          break;
        case 'PHR':
          partColor = 'rgba(187, 52, 238, 1)';
          break;
        case 'PGN':
          partColor = 'rgba(236, 238, 52, 1)';
          break;
        case 'AIL':
          partColor = 'rgba(61, 238, 52, 1)';
          break;
        case 'BDC':
          partColor = 'rgba(52, 211, 238, 1)';
          break;
        case 'CFR':
          partColor = 'rgba(255, 86, 88, 1)';
          break;
        case 'JUP':
          partColor = 'rgba(215, 113, 253, 1)';
          break;
        case 'CPT':
          partColor = 'rgba(113, 253, 245, 1)';
          break;
        case 'CLR':
          partColor = 'rgba(146, 89, 176, 1)';
          break;
        case 'INS':
          partColor = 'rgba(178, 253, 113, 1)';
          break;
        case 'TRP':
          partColor = 'rgba(232, 162, 0, 1)';
          break;
        default:
          partColor = 'black';
      }
      part.getPolygons().forEach((polygon) => {
        /* console.log('array of points ', polygon.toArrayOfPoints(
         {
           width: this.fimage.getScaledWidth(),
           height: this.fimage.getScaledHeight()
         }, {
           top: this.fimage.top,
           left: this.fimage.left
         }));  */
        const fPolygon = new fabric.Polygon(polygon.toArrayOfPoints(
          {
            width: this.fimage.getScaledWidth(),
            height: this.fimage.getScaledHeight()
          }, {
          top: this.fimage.top,
          left: this.fimage.left
        })
          , {
            fill: partColor, opacity: 0.40, visible: false
            //fill: partColor, opacity: 0.40, visible: true
          });
        fPolygon.setCoords();
        fPartPolygons.push(fPolygon);
      });

      const fPartText = new fabric.Text(part.getType(), {
        fontSize: 14,
        fontFamily: 'Sans Serif',
        fill: 'rgba(220,220,220,1)',
        opacity: 0,
        //opacity: 0.75,
        fontWeight: 'bold',
        originX: 'center',
        originY: 'bottom',
        draggable: false,
        selectable: false,
        lockRotation: true,
        hasControls: false,
        left: fPartPolygons[0].getCenterPoint().x,
        top: fPartPolygons[0].getCenterPoint().y,
        shadow: 'rgba(0,0,0,0.6) 2px 2px 1px'
      });

      fAllParts.push(new fabric.Group([...fPartPolygons, fPartText], {
        selectable: false, hasControls: false
      }));
    });
    this.fcanvas.add(...fAllParts);
  }

  handleRoiMoved = e => {
    this.editingRoi.emit(this.canvasId);
    const movedRoi = this.rois.array.find(c => {
      return c.id === e.target.parseId;
    });

    if (movedRoi) {
      const fTextBox = e.target.getObjects('rect')[0];
      //console.log('got fcircle ', e.target.getObjects('rect'));
      movedRoi.set('centerX', (e.target.left - this.fimage.left) / this.fimage.getScaledWidth());
      // !This formula leads to a small positive offset
      movedRoi.set('centerY', (e.target.top - this.fimage.top - fTextBox.strokeWidth / 2) / this.fimage.getScaledHeight() - movedRoi.get("radius"));
      //console.log('target moved to ', (e.target.left - this.fimage.left) / this.fimage.getScaledWidth(), (e.target.top - this.fimage.top - fTextBox.getScaledHeight()) / this.fimage.getScaledHeight());

      this._roiService.updateRoi(movedRoi).then(() => {
        // Update ROIs matrix
        this.rois.updateMovedRoi(
          e.target.parseId,
          movedRoi.get('centerX'),
          movedRoi.get('centerY')
        );
      }, error => console.error('Could not update ROI position : ', error.code, error.message)
      );
    }
  }

  // Cette méthode initialise FabricJS
  fabricInitializer() {
    if (this.fcanvas) this.fcanvas.clear()
    console.log('init fabric')
    if (this.currentMode === 'video' &&
      (this.listAnimation.empty()
        || this.cameraNumber === undefined
        || this.pictureNumber === undefined
        || !this.tchekId))
      return console.warn('fabricInitializer() called before ready state', { listAnimation: this.listAnimation, tchek: this.tchekId, camera: this.cameraNumber, picture: this.pictureNumber });

    // fabric.filterBackend = fabric.initFilterBackend();
    const canvas2dBackend = new fabric.Canvas2dFilterBackend();
    /*let webglBackend;
    try {
      webglBackend = new fabric.WebglFilterBackend();
      fabric.filterBackend = webglBackend;
    } catch (e) {
      console.warn(e);
      fabric.filterBackend = canvas2dBackend;
    } */
    fabric.filterBackend = canvas2dBackend;

    this.fcanvas = new fabric.CanvasEx('htmlCanvas' + this.canvasId, {
      selection: false,
      containerClass: 'canvasContainer' + this.canvasId
    });

    this.fcanvas.defaultCursor = 'move';

    $('.canvasContainer' + this.canvasId).css('margin', '0 auto');

    // Setting size according to viewport
    this.changeCanvasSize();

    // Setting canvas reference for annotation


    // Enabling Bootstrap popovers
    $('[data-toggle="popover"]').popover();


    // console.log(this.canvasId,'updating video to', this.listAnimation.get(this.cameraNumber).actualVideo);
    // Make sure the video start loading in the background
    if (this.currentMode === 'video') {
      $('#video' + this.canvasId).attr('src', this.listAnimation.get(this.cameraNumber).actualVideo);

      this.video.nativeElement.onerror = () => {
        this.video.nativeElement.crossOrigin = 'anonymous';
        this.handleVideoLoaded(undefined, true)
      };
      this.video.nativeElement.addEventListener("loadedmetadata", (e) => { this.handleVideoLoaded(e, true) }, { once: true });
      this.video.nativeElement.addEventListener('canplaythrough', this.handleVideoReady, { once: true });



    } else if (this.currentImage) {
      this.renderUid = uid(10)
      this.renderCanvas(this.currentImage.file.url(), this.renderUid.valueOf(), false, true);
    } else if (this.currentMode === 'underbody') {
      this._awsService.generateUrlPromise(this.deviceId + '/' + this.tchek.path + '/underbody.jpg').then(url => {
        this.renderUid = uid(10)
        this.renderCanvas(url, this.renderUid.valueOf(), true, true)
      })
    }

    $(window).resize(() => {
      this.changeCanvasSize();
      this.renderUid = uid(10)
      if (this.currentMode === 'video')
        this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture, this.renderUid.valueOf(), true);
      else if (this.currentImage)
        this.renderCanvas(this.currentImage.file.url(), this.renderUid.valueOf(), false, true);
    });

    // Handler for ROI double click
    this.fcanvas.on('mouse:dblclick', (opt) => {
      // Showing ROI edit modal
      const selection = this.fcanvas.getActiveObjects();
      // console.log('selection ', selection);
      if (selection.length === 1) {
        this._damageService.modalOpen({ type: 'edit', id: selection[0].damageId })
        //  $('#editRoiModal').modal({ backdrop: 'static', keyboard: false });
      } else if (this.editMode) {
        const evt = opt.e;
        // Setting this canvas as currently editing an ROI
        this.editingRoi.emit(this.canvasId);
        // Drawing new ROI
        this.isDrawing = true;
        const pointer = this.fcanvas.getPointer(evt);
        console.log('pointer img : ', pointer)
        this.origX = pointer.x;
        this.circle = new fabric.Circle({
          left: pointer.x,
          top: pointer.y,
          fill: 'transparent',
          radius: 50,
          strokeWidth: 2,
          stroke: this.style.newDamageColor ? this.style.newDamageColor : 'red',
          selectable: false,
          originX: 'center',
          originY: 'center'
        });
        this.fcanvas.add(this.circle);
        let picture = parseInt(this.toPictureName(this.pictureNumber), 10);
        let data = {
          type: 'create',
          circle: this.circle,
          cirlcleCenterX: (this.circle.left - this.fvideo.left) / this.fvideo.getScaledWidth(),
          cirlcleCenterY: (this.circle.top - this.fvideo.top) / this.fvideo.getScaledHeight(),
          cirlcleRadius: this.circle.radius / this.fvideo.getScaledWidth(),
          picture,
          currentMode: this.currentMode,
          image: this.currentImage ? this.currentImage.id : undefined,
          vehicleId: this.vehicleId,
          listAnimation: this.listAnimation,
          pictureNumber: this.pictureNumber,
          cameraNumber: this.cameraNumber,
          fvideo: this.fvideo,
          tchekId: this.tchekId,
          rois: this.rois,
          fcanvas: this.fcanvas
        }
        this.isDrawing = false
        this._damageService.modalOpen(data)
      }
    });

    // Handler for Part click
    this.fcanvas.on('mouse:up', (e) => {
      if (!this.partsMode || !e.target)
        return;

      if (e.target.type === 'group') {
        const fPartBasePolygons = [];
        let fPartBaseText;
        const fObjects = e.target.getObjects();
        for (let i = 0; i < fObjects.length; i++) {
          if (fObjects[i].type === 'polygon')
            fPartBasePolygons.push(fObjects[i]);
          else if (fObjects[i].type === 'text')
            fPartBaseText = fObjects[i];
        }

        if (fPartBasePolygons) {
          const topMargin = (this.fimage.getScaledHeight() / 100) * 15;
          const bottomMargin = (this.fimage.getScaledHeight() / 100) * 85;
          const leftMargin = (this.fimage.getScaledWidth() / 100) * 15;
          const rightMargin = (this.fimage.getScaledWidth() / 100) * 85;
          const textYDelta = (this.fimage.getScaledHeight() / 100) * 2;
          const textXDelta = (this.fimage.getScaledWidth() / 100) * 3;
          const fPartText = new fabric.Text(fPartBaseText.text, {
            fontSize: 16,
            fontFamily: 'Open Sans',
            fill: 'white',
            fontWeight: 'bold',
            originX: 'center',
            originY: 'center',
            draggable: false,
            selectable: false,
            lockRotation: true,
            hasControls: false,
            left: e.pointer.x,
            top: e.pointer.y,
            shadow: 'rgba(0,0,0,0.6) 2px 2px 1px'
          });
          const indicatorDirection = {
            up: true,
            right: false,
            down: false,
            left: false
          };

          // console.log('margins T.R.B.L. ', topMargin, rightMargin, bottomMargin, leftMargin, ' textDeltas ', textXDelta, textYDelta);
          // console.log('pointer ', e.pointer.x, e.pointer.y);
          if (e.pointer.y < topMargin) {
            fPartText.top += textYDelta;
            indicatorDirection.up = false;
            indicatorDirection.down = true;
          } else if (e.pointer.y > bottomMargin) {
            fPartText.top -= textYDelta;
          } else if (e.pointer.x > leftMargin && e.pointer.x < rightMargin) {
            fPartText.top -= textYDelta;
          }

          if (e.pointer.x < leftMargin) {
            fPartText.left += textXDelta;
            indicatorDirection.left = false;
            indicatorDirection.right = true;
          } else if (e.pointer.x > rightMargin) {
            fPartText.left -= textXDelta;
            indicatorDirection.left = true;
            indicatorDirection.right = false;
          } else {
            indicatorDirection.left = false;
            indicatorDirection.right = false;
          }


          const fSegmentEnd = new fabric.Circle({
            id: 'indicatorSegEnd',
            fill: 'white',
            radius: 5,
            selectable: false,
            originX: 'center',
            originY: 'center',
            draggable: false,
            lockRotation: true,
            hasControls: false
          });

          // Placing segment end point
          if (indicatorDirection.up) {
            fSegmentEnd.left = fPartText.getCenterPoint().x;
            fSegmentEnd.top = fPartText.getCenterPoint().y + fPartText.height;
          }
          if (indicatorDirection.right) {
            fSegmentEnd.left = fPartText.getCenterPoint().x - fPartText.width / 2 - 5;
            fSegmentEnd.top = fPartText.getCenterPoint().y;
          }
          if (indicatorDirection.down) {
            fSegmentEnd.left = fPartText.getCenterPoint().x;
            fSegmentEnd.top = fPartText.getCenterPoint().y - fPartText.height;
          }
          if (indicatorDirection.left) {
            fSegmentEnd.left = fPartText.getCenterPoint().x + fPartText.width / 2 + 5;
            fSegmentEnd.top = fPartText.getCenterPoint().y;
          }


          // console.log('segment', fSegment);
          // const fIndicatorGroup = new fabric.Group([fSegment, fSegmentStart, fSegmentEnd, fPartText]);
          const fIndicatorGroup = new fabric.Group([fPartText]);
          this.fcanvas.remove(fPartText);

          fPartBasePolygons.forEach((basePolygon) => {
            basePolygon.visible = true;
            basePolygon.selectable = false;
            basePolygon.draggable = false;
            // this.fcanvas.add(basePolygon);
          });
          this.fcanvas.add(fIndicatorGroup);
          this.fcanvas.bringToFront(fPartText);
          this.fcanvas.renderAll();
          setTimeout(function () {
            this.fcanvas.fxRemove(fIndicatorGroup);
            fPartBasePolygons.forEach((basePolygon) => {
              basePolygon.visible = false;
            });
          }.bind(this), 3000);
        }
      }
    });

    const thos = this;
    let pausePanning = false;
    let zoomStartScale;

    this.fcanvas.on('touch:longpress', function (opt) {
      if (thos.isMobile === true) {
        const evt = opt.e;
        const selection = thos.fcanvas.getActiveObjects();
        // console.log('selection ', selection);
        if (selection.length === 1) {
          thos._damageService.modalOpen({ type: 'edit', id: selection[0].damageId })
        } else if (thos.editMode !== true) {
          if (evt.type === 'touchend') { thos.onMouseUp() }
          if (evt.type === 'touchstart') {
            // Setting this canvas as currently editing an ROI
            thos.editingRoi.emit(thos.canvasId);
            // Drawing new ROI
            thos.isDrawing = true;
            const pointer = thos.fcanvas.getPointer(evt);
            console.log('pointer img : ', pointer)
            thos.origX = pointer.x;
            thos.circle = new fabric.Circle({
              left: pointer.x,
              top: pointer.y,
              fill: 'transparent',
              radius: 50,
              strokeWidth: 2,
              stroke: thos.style.newDamageColor ? thos.style.newDamageColor : 'red',
              selectable: false,
              originX: 'center',
              originY: 'center'
            });
            thos.fcanvas.add(thos.circle);
          }
        }
      }
    });

    this.fcanvas.on('touch:gesture', function (opt) {
      if (opt.e.touches && opt.e.touches.length === 2) {
        pausePanning = true;
        var point = new fabric.Point(opt.self.x, opt.self.y);
        if (opt.self.state == "start") {
          zoomStartScale = this.getZoom();
        }
        var delta = zoomStartScale * opt.self.scale;
        this.zoomToPoint(point, delta);
        pausePanning = false;
      }
    });

    this.fcanvas.on('touch:drag', function (opt) {
      const e = opt.e;
      if (e.type === 'mousemove') {
        if (!thos.fcanvas.imagePanActive) {
          if (!(opt && opt.e && opt.e.ctrlKey))
            return;
        }
        const e = opt.e;
        if (thos.fcanvas.isDragging) {
          thos.fcanvas.viewportTransform[4] += e.clientX - thos.fcanvas.lastPosX;
          thos.fcanvas.viewportTransform[5] += e.clientY - thos.fcanvas.lastPosY;
          thos.fcanvas.requestRenderAll();
          thos.fcanvas.lastPosX = e.clientX;
          thos.fcanvas.lastPosY = e.clientY;
        }
      } else if (thos.editMode === false
        && pausePanning === false
        && e.type === 'touchmove'
        && opt.e.touches.length === 1) {
        let currentX = e.touches[0].clientX;
        let currentY = e.touches[0].clientY;
        let xChange = currentX - thos.fcanvas.lastPosX;
        let yChange = currentY - thos.fcanvas.lastPosY;
        if ((Math.abs(currentX - thos.fcanvas.lastPosX) <= 50)
          && (Math.abs(currentY - thos.fcanvas.lastPosY) <= 50)) {
          //thos.fcanvas.viewportTransform[4] += xChange;
          //thos.fcanvas.viewportTransform[5] += yChange;
          //thos.fcanvas.requestRenderAll();
          var delta = new fabric.Point(xChange, yChange);
          thos.fcanvas.relativePan(delta);
        }
        thos.fcanvas.lastPosX = e.touches[0].clientX;
        thos.fcanvas.lastPosY = e.touches[0].clientY;
        thos.fcanvas.setCursor(thos.fcanvas.defaultCursor);
      }

      if (opt.e.touches)
        thos.resetViewerCanvas(opt.e.touches.length)
    });

    // Handlers to move the image on the canvas
    this.fcanvas.on('mouse:down', this.beginImagePanningHandler.bind(this));
    this.fcanvas.on('mouse:up', this.endImagePanningHandler.bind(this));

    // Handler to keep cursor set
    this.fcanvas.on('mouse:move', () => { this.fcanvas.setCursor(this.fcanvas.defaultCursor); });

    this.enableImageMovement();
    /* SelectedPov.currentPicture can be undefined at this point if connection is slow
    console.log('SelectedPOV : ',this.selectedPOV);*/
    // TODO: Render hires pictures here
    // this.renderCanvas(this.listAnimation.get(this.cameraNumber).currentPicture);

    // Listening for ROIs selection
    this.fcanvas.on('selection:created', e => {
      this.editingRoi.emit(this.canvasId);
      this._roiService.setRoiToEdit(this.rois.findById(e.target.parseId), this.canvasId);
    });
    this.fcanvas.on('selection:updated', e => {
      this.editingRoi.emit(this.canvasId);
      this._roiService.setRoiToEdit(this.rois.findById(e.target.parseId), this.canvasId);
    });

    // Listening for ROIs movement
    this.fcanvas.on('object:moved', this.handleRoiMoved);

    // Listening for mouswheel movement to zoom in/out
    this.fcanvas.on('mouse:wheel', function (opt) {
      const delta = -opt.e.deltaY;
      let zoom = this.getZoom();
      zoom *= 1 + delta / 200;
      if (zoom > 20) zoom = 20;
      if (zoom < 1)//&& this.currentMode === 'video')
        zoom = 1;
      // if (zoom < 0.3 && this.currentMode !== 'video')
      //   zoom = 0.3;

      this.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });

    $(document).on('keydown', function (event) {
      const key = event.which || event.keyCode;
      let selection: any;
      // console.log('keydown', event.which, event.keyCode);

      // Standard keys
      switch (key) {
        case 8: // Backspace
        case 46: // Delete
          if (!this.annotateMode) {
            selection = this.fcanvas.getActiveObjects();
            if (selection.length > 0) {
              this._damageService.modalOpen({ type: 'delete', id: selection[0].damageId })
              //this.removeRoi(selection);
              this.fcanvas.discardActiveObject();
            }
          }
          break;
        case 187: // Equal
        case 61: // for Gecko compatibility
          // console.log('canSeeMasks?', parse.User.current().get('canSeeMasks'));
          if (parse.User.current().get('canSeeMasks'))
            this.toggleAutoRoisMasks();
          break;

        default:
          break;
      }

      // Update modifier keys status
      this.shiftKey = event.shiftKey;
      this.altKey = event.altKey;
      this.ctrlKey = event.ctrlKey;
    }.bind(this));

    $(document).on('keyup', event => {
      switch (event.keyCode) {
        case 27: // Escape
          this.changeCanvasSize();
          break;

        default:
          break;
      }

    });

    if (this.stateValue === CanvasState.Initializing)
      this.updateState(CanvasState.LoadingPicture);

    //end
  }


  tchekInitializer(): Promise<any> {

    return new Promise((resolve, reject) => {
      if (this.currentMode === 'image') {
        console.log('init tchek image')

        // Generating URLs from AWS
        const cpPromises = [];
        const avPromises = [];
        const mpPromises = [];
        const allPromises = [];
        this.listAnimation = new ListAnimation();
        this.listAnimation.array.push(new Animation({
          numberPicture: '0',
          folder: '0',
          folderId: '0',
          totalPictures: 0,
          path: '0',
          descCam: '0',
          name: '0',
          date: new Date(),
          currentPicture: undefined,
          actualVideo: undefined,
          miniPicture: undefined
        }));


        allPromises.push(Promise.all(cpPromises)); // => resolvedPromises[0]
        allPromises.push(Promise.all(avPromises)); // => resolvedPromises[1]
        allPromises.push(Promise.all(mpPromises)); // => resolvedPromises[2]
        allPromises.push(this._roiService.getTchekRois(this.tchekId)); // => resolvedPromises[3]
        allPromises.push(this._damageService.getByTchek(this.tchekId)); // => resolvedPromises[4]


        Promise.all(allPromises).then(resolvedPromises => {
          // console.log('All promises resolutions :', resolvedPromises);
          // At this point, all media of all sizes have been loadedfolder
          this.listAnimation.array.forEach(({ folder }) => {
            this.listAnimation.setCurrentPicture(folder, resolvedPromises[0][parseInt(folder, 10)]);
            // classification video
            this.listAnimation.setActualVideo(folder, resolvedPromises[1][parseInt(folder, 10)]);
            this.listAnimation.setMiniPicture(folder, resolvedPromises[2][parseInt(folder, 10)]);
          });

          console.log('list rois canvas ', resolvedPromises[3])
          // Saving ROIs for all animations
          this.rois.array = resolvedPromises[3]
            .filter(r => {
              let verif = false;
              resolvedPromises[4].forEach(d => {
                if (r.get("damagePtr") === undefined || r.get("damagePtr").id === undefined)
                  verif = false
                else if (d && d.id === r.get("damagePtr").id)
                  verif = true;
              })
              return verif
            });

          // console.log(this.canvasId, ' resolving listAnimation ', this.listAnimation);
          resolve(this.listAnimation);
        }, error => reject(error));

      } else
        this._tchekService.getFolder(this.tchekId).then(folders => {
          console.log('init tchek')
          try {
            const firstFolderTransform = this._parseFunction.getFolder(folders[0]);
            if (!firstFolderTransform.company.logo || firstFolderTransform.company.logo === 'undefined')
              this.vehicleId = firstFolderTransform.tchek.vehicle.id;

            const baseURLPicture = environment.finalBaseURL + this.deviceId;

            // Generating URLs from AWS
            const cpPromises = [];
            const avPromises = [];
            const mpPromises = [];
            const allPromises = [];
            // xxPromises[i] = folder.url <=> i = folder.name
            // console.log('Matrix before generating promises ', this.listAnimation.array);
            this.listAnimation = new ListAnimation();
            folders.forEach(folder => {
              folder = this._parseFunction.getFolder(folder);
              // TODO: Configure way behavior
              // folder.name = way ? folder.name : inverseCam(Number.parseInt(folder.name));
              cpPromises[Number.parseInt(folder.name)] = this._awsService.generateUrlPromise(this.deviceId + '/' +
                folder.tchek.path +
                '/' +
                folder.name +
                '/' +
                this.toPictureName(this.pictureNumber, folder.totalPictures) +
                CanvasComponent._imageExtension, this.ipMachine);
              // this.listAnimation[i].currentPicture = url;
              avPromises[Number.parseInt(folder.name)] = this._awsService.generateUrlPromise(this.deviceId + '/' +
                folder.tchek.path +
                '/' +
                folder.name +
                '/moyen.mp4', this.ipMachine);
              // this.listAnimation[i].actualVideo = url;
              mpPromises[Number.parseInt(folder.name)] = this._awsService.generateUrlPromise(this.deviceId + '/' +
                folder.tchek.path +
                '/mini/' +
                folder.name +
                '/' +
                this.toPictureName(this.pictureNumber, folder.totalPictures) +
                CanvasComponent._imageExtension, this.ipMachine);
              // this.listAnimation[i].miniPicture = url;
              // console.log('added promise', folder.name, ' : cp=', cpPromises[Number.parseInt(folder.name)]);

              this.listAnimation.array.push(new Animation({
                numberPicture: this.toPictureName(this.pictureNumber, folder.totalPictures),
                folder: folder.name,
                folderId: folder.id,
                totalPictures: folder.totalPictures,
                path: baseURLPicture,
                descCam: folder.descCam,
                name: folder.tchek.path,
                date: folder.tchek.date,
                currentPicture: undefined,
                actualVideo: undefined,
                miniPicture: undefined
              }));
              // console.log('Pushing animation ', JSON.stringify(this.listAnimation.array));
            });

            allPromises.push(Promise.all(cpPromises)); // => resolvedPromises[0]
            allPromises.push(Promise.all(avPromises)); // => resolvedPromises[1]
            allPromises.push(Promise.all(mpPromises)); // => resolvedPromises[2]
            allPromises.push(this._roiService.getTchekRois(this.tchekId)); // => resolvedPromises[3]
            allPromises.push(this._damageService.getByTchek(this.tchekId)); // => resolvedPromises[4]


            Promise.all(allPromises).then(resolvedPromises => {
              // console.log('All promises resolutions :', resolvedPromises);
              // At this point, all media of all sizes have been loadedfolder
              this.listAnimation.array.forEach(({ folder }) => {
                this.listAnimation.setCurrentPicture(folder, resolvedPromises[0][parseInt(folder, 10)]);
                // classification video
                this.listAnimation.setActualVideo(folder, resolvedPromises[1][parseInt(folder, 10)]);
                this.listAnimation.setMiniPicture(folder, resolvedPromises[2][parseInt(folder, 10)]);
              });

              //      console.log('list rois canvas ', resolvedPromises[3])
              // Saving ROIs for all animations
              this.rois.array = resolvedPromises[3]
                .filter(r => {
                  let verif = false;
                  resolvedPromises[4].forEach(d => {
                    if (r.get("damagePtr") === undefined || r.get("damagePtr").id === undefined)
                      verif = false
                    else if (d && d.id === r.get("damagePtr").id)
                      verif = true;
                  })
                  return verif
                });

              // console.log(this.canvasId, ' resolving listAnimation ', this.listAnimation);
              resolve(this.listAnimation);
            }, error => reject(error));
          } catch (error) { }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/element/canvas/canvas.component.ts